import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type AcademicSession = {
  __typename?: 'AcademicSession';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sourceKindId?: Maybe<Scalars['Int']>;
  sourceKind?: Maybe<Scalars['String']>;
  sisId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  dateTermStart: Scalars['DateTime'];
  dateTermEnd: Scalars['DateTime'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  status: AcademicSessionStatus;
  active: Scalars['Boolean'];
  default: Scalars['Boolean'];
};

export type AcademicSessionCreateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  dateTermStart: Scalars['DateTime'];
  dateTermEnd: Scalars['DateTime'];
  sourceKind?: Maybe<SourceKind>;
};

export enum AcademicSessionOrderField {
  Id = 'ID',
  Name = 'NAME',
  SourceId = 'SOURCE_ID',
  SourceKindId = 'SOURCE_KIND_ID',
  OrganizationId = 'ORGANIZATION_ID'
}

export enum AcademicSessionStatus {
  Previous = 'PREVIOUS',
  Current = 'CURRENT',
  Future = 'FUTURE'
}

export type AcademicSessionUpdateInput = {
  externalId?: Maybe<ExternalIdUpdateInput>;
  sisId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  sourceKindId?: Maybe<Scalars['Int']>;
  sourceKind?: Maybe<SourceKind>;
  dateTermStart?: Maybe<Scalars['DateTime']>;
  dateTermEnd?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type AcademicSessionWhereInput = {
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<ExternalIdInput>;
};

export type AcademicSessionsDateRangeInput = {
  dateStart: Scalars['DateTime'];
  dateEnd: Scalars['DateTime'];
};

export type AcademicSessionsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<AcademicSessionOrderField>;
};

export type AcademicSessionsUpdateInput = {
  dateTermStart?: Maybe<Scalars['DateTime']>;
  dateTermEnd?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type AcademicSessionsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  status?: Maybe<AcademicSessionStatus>;
  dateTermRange?: Maybe<AcademicSessionsDateRangeInput>;
  active?: Maybe<Scalars['Boolean']>;
  default?: Maybe<Scalars['Boolean']>;
  AND?: Maybe<Array<AcademicSessionsWhereInput>>;
  OR?: Maybe<Array<AcademicSessionsWhereInput>>;
};

export enum AnswerFormat {
  CharacterChart = 'CHARACTER_CHART',
  Radio = 'RADIO'
}

export type AnswerType = {
  __typename?: 'AnswerType';
  id: Scalars['Int'];
  format: AnswerFormat;
  options: Array<AnswerTypeOption>;
};

export type AnswerTypeOption = {
  __typename?: 'AnswerTypeOption';
  id: Scalars['Int'];
  text: Scalars['String'];
  pointValue?: Maybe<Scalars['Int']>;
};

export type App = {
  __typename?: 'App';
  id: Scalars['Int'];
  name: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
  product?: Maybe<Product>;
  productDetails?: Maybe<AppProductDetails>;
  accessDetails?: Maybe<AppAccessDetails>;
  purchaseDetails?: Maybe<AppPurchaseDetails>;
};

export type AppAccessDetails = {
  __typename?: 'AppAccessDetails';
  bannerUrl: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  iosUrl?: Maybe<Scalars['String']>;
};

export type AppProductDetails = {
  __typename?: 'AppProductDetails';
  code: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type AppPurchaseDetails = {
  __typename?: 'AppPurchaseDetails';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  salesQuoteUrl?: Maybe<Scalars['String']>;
  webstoreUrl?: Maybe<Scalars['String']>;
};

export type Assessment = {
  id: Scalars['Int'];
  type: AssessmentType;
  educatorPacketId?: Maybe<Scalars['Int']>;
  educatorPacket?: Maybe<EducatorPacket>;
  totalPointsPossible: Scalars['Int'];
  assessmentDomains: Array<AssessmentDomain>;
  assessmentSectionQuestions: Array<AssessmentSectionQuestion>;
};

export type AssessmentDomain = {
  __typename?: 'AssessmentDomain';
  domain: Domain;
  totalPointsPossible: Scalars['Int'];
  assessmentSections: Array<AssessmentSection>;
};

export enum AssessmentOrderField {
  Id = 'ID',
  Type = 'TYPE'
}

export type AssessmentQuestion = {
  __typename?: 'AssessmentQuestion';
  id: Scalars['Int'];
  text: Scalars['String'];
  instructions?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  answerTypeId: Scalars['Int'];
  answerType: AnswerType;
  pointsPossible: Scalars['Int'];
  data?: Maybe<Scalars['JSON']>;
};

export type AssessmentReport = {
  __typename?: 'AssessmentReport';
  assessmentId: Scalars['Int'];
  totalStats: Array<StudentAssessmentReportTotalStats>;
  reportDomains: Array<StudentAssessmentReportDomain>;
  reportSections: Array<StudentAssessmentReportSection>;
  assessment: Assessment;
};

export type AssessmentReportWhereInput = {
  assessmentId: Scalars['Int'];
  studentId: Array<Scalars['Int']>;
};

export type AssessmentReportsWhereInput = {
  assessmentType: AssessmentType;
  productCurriculumId: Scalars['Int'];
  studentId: Array<Scalars['Int']>;
};

export type AssessmentSection = {
  __typename?: 'AssessmentSection';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  totalPointsPossible: Scalars['Int'];
  assessmentSectionQuestions: Array<AssessmentSectionQuestion>;
};

export type AssessmentSectionQuestion = {
  __typename?: 'AssessmentSectionQuestion';
  assessmentQuestion: AssessmentQuestion;
  outcomes: Array<StudentAssessmentOutcome>;
};


export type AssessmentSectionQuestionOutcomesArgs = {
  where?: Maybe<AssessmentSectionQuestionOutcomesWhereInput>;
};

export type AssessmentSectionQuestionOutcomesWhereInput = {
  studentId?: Maybe<Array<Scalars['Int']>>;
};

export enum AssessmentType {
  Benchmark = 'BENCHMARK',
  Unit = 'UNIT',
  Week = 'WEEK'
}

export type AssessmentWhereInput = {
  id: Scalars['Int'];
};

export type AssessmentsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<AssessmentOrderField>;
};

export type AssessmentsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  productCurriculumId?: Maybe<Array<Scalars['Int']>>;
  type?: Maybe<Array<AssessmentType>>;
};

export type AssignAvailableLicenseInput = {
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  productCurriculum?: Maybe<ProductIdentifierInput>;
  updates?: Maybe<LicenseAssignmentUpdateInput>;
};

export type AssignAvailableLicenseWhereInput = {
  expiresAfter?: Maybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  product?: Maybe<ProductIdentifierInput>;
  productFamily?: Maybe<ProductIdentifierInput>;
};

export enum AssigneeType {
  Student = 'STUDENT',
  User = 'USER'
}

export type BaseSettingCreateInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export type BatchMutationResult = {
  __typename?: 'BatchMutationResult';
  count?: Maybe<Scalars['Int']>;
};

export type BenchmarkAssessment = Assessment & {
  __typename?: 'BenchmarkAssessment';
  id: Scalars['Int'];
  type: AssessmentType;
  educatorPacketId?: Maybe<Scalars['Int']>;
  educatorPacket?: Maybe<EducatorPacket>;
  totalPointsPossible: Scalars['Int'];
  assessmentDomains: Array<AssessmentDomain>;
  assessmentSectionQuestions: Array<AssessmentSectionQuestion>;
  details: Array<BenchmarkAssessmentDetails>;
};

export type BenchmarkAssessmentDetails = {
  __typename?: 'BenchmarkAssessmentDetails';
  productCurriculumId: Scalars['Int'];
  productCurriculum: ProductCurriculum;
  period: BenchmarkPeriod;
};

export type BenchmarkChecklist = Checklist & {
  __typename?: 'BenchmarkChecklist';
  id: Scalars['Int'];
  type: AssessmentType;
  totalPointsPossible: Scalars['Int'];
  checklistDomains: Array<ChecklistDomain>;
  checklistObservations: Array<ChecklistObservation>;
  details: Array<BenchmarkChecklistDetails>;
};

export type BenchmarkChecklistDetails = {
  __typename?: 'BenchmarkChecklistDetails';
  productCurriculumId: Scalars['Int'];
  productCurriculum: ProductCurriculum;
  period: BenchmarkPeriod;
};

export enum BenchmarkPeriod {
  Beginning = 'BEGINNING',
  Middle = 'MIDDLE',
  End = 'END'
}

export type BulkAssignAvailableLicenseInput = {
  expiresAfter?: Maybe<Scalars['DateTime']>;
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  product?: Maybe<ProductIdentifierInput>;
  productCurriculum?: Maybe<ProductIdentifierInput>;
  productFamily?: Maybe<ProductIdentifierInput>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignmentUpdateInput>;
};

export type BulkAssignAvailableWhereInput = {
  expiresAfter?: Maybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
};

export type BulkAssignResult = {
  __typename?: 'BulkAssignResult';
  request: LicenseAssignRequest;
  license?: Maybe<License>;
  error?: Maybe<Scalars['String']>;
};

export type BulkGroupEnrollmentActionGroupCategoryRequest = {
  __typename?: 'BulkGroupEnrollmentActionGroupCategoryRequest';
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export type BulkGroupEnrollmentActionGroupRequest = {
  __typename?: 'BulkGroupEnrollmentActionGroupRequest';
  classroomId: Scalars['Int'];
  groupCategory?: Maybe<BulkGroupEnrollmentActionGroupCategoryRequest>;
  name: Scalars['String'];
};

export type BulkGroupEnrollmentActionInput = {
  action: GroupEnrollmentAction;
  studentId: Scalars['Int'];
  groupId?: Maybe<Scalars['Int']>;
  group?: Maybe<GroupEnrollmentGroupInput>;
};

export type BulkGroupEnrollmentActionRequest = {
  __typename?: 'BulkGroupEnrollmentActionRequest';
  studentId: Scalars['Int'];
  groupId?: Maybe<Scalars['Int']>;
  group?: Maybe<BulkGroupEnrollmentActionGroupRequest>;
};

export type BulkGroupEnrollmentActionResult = {
  __typename?: 'BulkGroupEnrollmentActionResult';
  request: BulkGroupEnrollmentActionRequest;
  groupEnrollment?: Maybe<GroupEnrollment>;
  error?: Maybe<Scalars['String']>;
};

export type BulkLicenseActionInput = {
  action: LicenseAction;
  expiresAfter?: Maybe<Scalars['DateTime']>;
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  product?: Maybe<ProductIdentifierInput>;
  productCurriculum?: Maybe<ProductIdentifierInput>;
  productFamily?: Maybe<ProductIdentifierInput>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignmentUpdateInput>;
};

export type BulkLicenseActionResult = {
  __typename?: 'BulkLicenseActionResult';
  request: LicenseActionRequest;
  licenses?: Maybe<Array<License>>;
  error?: Maybe<Scalars['String']>;
};

export type BulkLicenseActionWhereInput = {
  expiresAfter?: Maybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
};

export type Checklist = {
  id: Scalars['Int'];
  type: AssessmentType;
  totalPointsPossible: Scalars['Int'];
  checklistDomains: Array<ChecklistDomain>;
  checklistObservations: Array<ChecklistObservation>;
};

export type ChecklistDomain = {
  __typename?: 'ChecklistDomain';
  domain: Domain;
  totalPointsPossible: Scalars['Int'];
  checklistObservations: Array<ChecklistObservation>;
};

export type ChecklistObservation = {
  __typename?: 'ChecklistObservation';
  observation: Observation;
  outcomes: Array<StudentChecklistOutcome>;
};


export type ChecklistObservationOutcomesArgs = {
  where?: Maybe<ChecklistObservationOutcomesWhereInput>;
};

export type ChecklistObservationOutcomesWhereInput = {
  studentId?: Maybe<Array<Scalars['Int']>>;
};

export enum ChecklistOrderField {
  Id = 'ID',
  Type = 'TYPE'
}

export type ChecklistWhereInput = {
  id: Scalars['Int'];
};

export type ChecklistsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ChecklistOrderField>;
};

export type ChecklistsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  productCurriculumId?: Maybe<Array<Scalars['Int']>>;
  type?: Maybe<Array<AssessmentType>>;
};

export type Classroom = {
  __typename?: 'Classroom';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sisId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  color: Scalars['String'];
  loginType: StudentLoginType;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  academicSessionId?: Maybe<Scalars['Int']>;
  academicSession?: Maybe<AcademicSession>;
  studentCount: Scalars['Int'];
  students?: Maybe<Array<Student>>;
  users?: Maybe<Array<UserClassroomEnrollment>>;
  settings?: Maybe<Array<ClassroomSetting>>;
  stats: ClassroomStats;
  status?: Maybe<ClassroomStatus>;
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  groups?: Maybe<Array<Group>>;
  licenseUsage?: Maybe<Array<ClassroomLicenseUsage>>;
};


export type ClassroomUsersArgs = {
  where?: Maybe<UsersWhereInput>;
};


export type ClassroomSettingsArgs = {
  where?: Maybe<ClassroomSettingsWhereInput>;
  orderBy?: Maybe<ClassroomSettingsOrderInput>;
};


export type ClassroomGroupsArgs = {
  where?: Maybe<GroupsWhereInput>;
  orderBy?: Maybe<GroupsOrderInput>;
};


export type ClassroomLicenseUsageArgs = {
  where?: Maybe<LicenseUsageWhereInput>;
};

export type ClassroomCreateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  academicSessionId?: Maybe<Scalars['Int']>;
  loginType?: Maybe<StudentLoginType>;
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  students?: Maybe<Array<StudentCreateInput>>;
  studentEnrollments?: Maybe<Array<Scalars['Int']>>;
  userEnrollments?: Maybe<Array<UserEnrollmentInput>>;
  settings?: Maybe<Array<BaseSettingCreateInput>>;
};

export type ClassroomLicenseUsage = {
  __typename?: 'ClassroomLicenseUsage';
  product: Product;
  productId: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  assignedCount: Scalars['Int'];
};

export enum ClassroomOrderField {
  Id = 'ID',
  OrganizationId = 'ORGANIZATION_ID',
  Name = 'NAME',
  SourceId = 'SOURCE_ID',
  SourceKindId = 'SOURCE_KIND_ID',
  DateArchived = 'DATE_ARCHIVED',
  DateCreated = 'DATE_CREATED',
  DateRemoved = 'DATE_REMOVED'
}

export type ClassroomPrivilege = {
  __typename?: 'ClassroomPrivilege';
  id: Scalars['Int'];
  name: Scalars['String'];
  displayName: Scalars['String'];
};

export enum ClassroomPrivilegeOrderField {
  Id = 'ID',
  Name = 'NAME',
  DisplayName = 'DISPLAY_NAME'
}

export type ClassroomPrivilegeWhereInput = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ClassroomPrivilegesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ClassroomPrivilegeOrderField>;
};

export type ClassroomPrivilegesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
};

export type ClassroomRole = {
  __typename?: 'ClassroomRole';
  id: Scalars['Int'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  classification: ClassroomRoleClassification;
  appId?: Maybe<Scalars['Int']>;
  app?: Maybe<App>;
  organizationId?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  privileges?: Maybe<Array<Maybe<ClassroomPrivilege>>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum ClassroomRoleClassification {
  Educator = 'EDUCATOR',
  Coeducator = 'COEDUCATOR'
}

export enum ClassroomRoleOrderField {
  Id = 'ID',
  Name = 'NAME',
  DisplayName = 'DISPLAY_NAME',
  App = 'APP',
  Organization = 'ORGANIZATION'
}

export type ClassroomRoleWhereInput = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ClassroomRolesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ClassroomRoleOrderField>;
};

export type ClassroomRolesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
};

export type ClassroomSetting = {
  __typename?: 'ClassroomSetting';
  /** @deprecated Field no longer supported */
  id: Scalars['Int'];
  app?: Maybe<App>;
  appId?: Maybe<Scalars['Int']>;
  classroom: Classroom;
  classroomId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type ClassroomSettingCreateInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  classroomId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export enum ClassroomSettingOrderField {
  AppId = 'APP_ID',
  Setting = 'SETTING',
  ClassroomId = 'CLASSROOM_ID'
}

export type ClassroomSettingUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type ClassroomSettingWhereInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  classroomId: Scalars['Int'];
  setting: Scalars['String'];
};

export type ClassroomSettingsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ClassroomSettingOrderField>;
};

export type ClassroomSettingsUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type ClassroomSettingsWhereInput = {
  appId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  appName?: Maybe<Array<Maybe<Scalars['String']>>>;
  classroomId?: Maybe<Array<Scalars['Int']>>;
  setting?: Maybe<Array<Scalars['String']>>;
};

export type ClassroomStats = {
  __typename?: 'ClassroomStats';
  studentCount: Scalars['Int'];
  userCount: Scalars['Int'];
};

export enum ClassroomStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Removed = 'REMOVED'
}

export type ClassroomUpdateInput = {
  externalId?: Maybe<ExternalIdUpdateInput>;
  sisId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  academicSessionId?: Maybe<Scalars['Int']>;
  loginType?: Maybe<StudentLoginType>;
  userEnrollments?: Maybe<Array<UserEnrollmentInput>>;
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type ClassroomWhereInput = {
  externalId?: Maybe<ExternalIdInput>;
  id?: Maybe<Scalars['Int']>;
};

export type ClassroomsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ClassroomOrderField>;
};

export type ClassroomsUpdateInput = {
  organizationId?: Maybe<Scalars['Int']>;
  academicSessionId?: Maybe<Scalars['Int']>;
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type ClassroomsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  educator?: Maybe<UsersWhereInput>;
  coEducator?: Maybe<UsersWhereInput>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  name?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  organization?: Maybe<OrganizationsWhereInput>;
  academicSessionId?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Array<ClassroomStatus>>;
  AND?: Maybe<Array<ClassroomsWhereInput>>;
  OR?: Maybe<Array<ClassroomsWhereInput>>;
};

export type Contact = {
  __typename?: 'Contact';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sisId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  students?: Maybe<Array<Student>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type ContactInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  studentIds?: Maybe<Array<Scalars['Int']>>;
};

export enum ContactOrderField {
  Id = 'ID',
  SourceId = 'SOURCE_ID',
  SourceKindId = 'SOURCE_KIND_ID'
}

export type ContactStudentRemoveInput = {
  studentId?: Maybe<Array<Scalars['Int']>>;
  contactId: Scalars['Int'];
};

export type ContactUpdateInput = {
  externalId?: Maybe<ExternalIdUpdateInput>;
  sisId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ContactWhereInput = {
  externalId?: Maybe<ExternalIdInput>;
  id?: Maybe<Scalars['Int']>;
};

export type ContactsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ContactOrderField>;
};

export type ContactsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  email?: Maybe<Array<Scalars['String']>>;
  email_contains?: Maybe<Scalars['String']>;
  firstName?: Maybe<Array<Scalars['String']>>;
  firstName_contains?: Maybe<Scalars['String']>;
  lastName?: Maybe<Array<Scalars['String']>>;
  lastName_contains?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<ContactsWhereInput>>;
  OR?: Maybe<Array<ContactsWhereInput>>;
};

export type CreateEntityLicenseAssignInput = {
  productId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
};



export type DefaultGroupSetting = {
  __typename?: 'DefaultGroupSetting';
  gradeLevels: Array<Scalars['String']>;
  productCodes: Array<Scalars['String']>;
  group: GroupCreate;
};

export type Domain = {
  __typename?: 'Domain';
  id: Scalars['Int'];
  code: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  productCurriculums: Array<ProductCurriculum>;
};

export enum DomainOrderField {
  Id = 'ID',
  Code = 'CODE',
  Title = 'TITLE'
}

export type DomainWhereInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
};

export type DomainsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<DomainOrderField>;
};

export type DomainsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
  productCurriculumId?: Maybe<Array<Scalars['Int']>>;
};

export type EducatorPacket = {
  __typename?: 'EducatorPacket';
  id: Scalars['Int'];
  title: Scalars['String'];
  resources: Array<EducatorPacketResource>;
};

export enum EducatorPacketOrderField {
  Id = 'ID',
  Title = 'TITLE'
}

export type EducatorPacketResource = {
  __typename?: 'EducatorPacketResource';
  id: Scalars['Int'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type EducatorPacketWhereInput = {
  id: Scalars['Int'];
};

export type EducatorPacketsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<EducatorPacketOrderField>;
};

export type EducatorPacketsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  productCurriculumId?: Maybe<Array<Scalars['Int']>>;
};

export type Enrollment = {
  __typename?: 'Enrollment';
  id: Scalars['Int'];
  classroom: Classroom;
  student?: Maybe<Student>;
  user?: Maybe<User>;
  classroomRole?: Maybe<ClassroomRole>;
  removedDate?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum EnrollmentOrderField {
  StudentId = 'STUDENT_ID',
  UserId = 'USER_ID',
  ClassroomRole = 'CLASSROOM_ROLE',
  ClassroomRoleId = 'CLASSROOM_ROLE_ID'
}

export type EnrollmentWhereInput = {
  id: Scalars['Int'];
};

export type EnrollmentsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<EnrollmentOrderField>;
};

export type EnrollmentsWhereInput = {
  id?: Maybe<Array<Maybe<Scalars['Int']>>>;
  classroomId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  studentId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  userId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  classroomRoleId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  classroomRole?: Maybe<Array<Maybe<UserRole>>>;
};

export type ExternalId = {
  __typename?: 'ExternalId';
  sourceKindId: Scalars['Int'];
  sourceKind: SourceKind;
  sourceId: Scalars['String'];
};

export type ExternalIdInput = {
  sourceKind: SourceKind;
  sourceId: Scalars['String'];
};

export type ExternalIdUpdateInput = {
  sourceKind?: Maybe<SourceKind>;
  sourceId?: Maybe<Scalars['String']>;
};

export type FeatureToggle = {
  __typename?: 'FeatureToggle';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  app: App;
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
  data?: Maybe<Scalars['JSON']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type FeatureToggleInput = {
  appId: Scalars['Int'];
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
  data?: Maybe<Scalars['JSON']>;
};

export enum FeatureToggleOrderField {
  Id = 'ID',
  AppId = 'APP_ID',
  Name = 'NAME',
  Enabled = 'ENABLED',
  DateCreated = 'DATE_CREATED'
}

export type FeatureToggleUpdateInput = {
  appId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  data?: Maybe<Scalars['JSON']>;
};

export type FeatureToggleWhereInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
};

export type FeatureTogglesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<FeatureToggleOrderField>;
};

export type FeatureTogglesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  appName?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type FindAvailableLicenseWhereInput = {
  expiresAfter?: Maybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: Maybe<Scalars['Boolean']>;
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  product?: Maybe<ProductIdentifierInput>;
  productFamily?: Maybe<ProductIdentifierInput>;
  limit?: Maybe<Scalars['Int']>;
};

export type Group = {
  __typename?: 'Group';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  app: App;
  classroomId: Scalars['Int'];
  classroom: Classroom;
  groupCategoryId: Scalars['Int'];
  groupCategory: GroupCategory;
  name: Scalars['String'];
  groupEnrollments: Array<Maybe<GroupEnrollment>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type GroupCategoriesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<GroupCategoryOrderField>;
};

export type GroupCategoriesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  classroomId?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
};

export type GroupCategory = {
  __typename?: 'GroupCategory';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  app: App;
  classroomId: Scalars['Int'];
  classroom: Classroom;
  name: Scalars['String'];
  groups: Array<Maybe<Group>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type GroupCategoryCreate = {
  __typename?: 'GroupCategoryCreate';
  id?: Maybe<Scalars['Int']>;
  appId: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupCategoryCreateInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export enum GroupCategoryOrderField {
  Id = 'ID',
  ClassroomId = 'CLASSROOM_ID',
  Name = 'NAME'
}

export type GroupCategoryUpsertInput = {
  id?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type GroupCategoryWhereInput = {
  id?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type GroupCreate = {
  __typename?: 'GroupCreate';
  id?: Maybe<Scalars['Int']>;
  appId: Scalars['Int'];
  name: Scalars['String'];
  groupCategory?: Maybe<GroupCategoryCreate>;
};

export type GroupCreateInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  groupCategory: GroupCategoryCreateInput;
  name: Scalars['String'];
};

export type GroupEnrollment = {
  __typename?: 'GroupEnrollment';
  id: Scalars['Int'];
  groupId: Scalars['Int'];
  group?: Maybe<Group>;
  studentId: Scalars['Int'];
  student?: Maybe<Student>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum GroupEnrollmentAction {
  Enroll = 'ENROLL',
  Unenroll = 'UNENROLL'
}

export type GroupEnrollmentGroupCategoryInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupEnrollmentGroupInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  groupCategory?: Maybe<GroupEnrollmentGroupCategoryInput>;
  name: Scalars['String'];
};

export enum GroupEnrollmentOrderField {
  Id = 'ID',
  GroupId = 'GROUP_ID',
  StudentId = 'STUDENT_ID'
}

export type GroupEnrollmentWhereInput = {
  id?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

export type GroupEnrollmentsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<GroupEnrollmentOrderField>;
};

export type GroupEnrollmentsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  groupId?: Maybe<Array<Scalars['Int']>>;
  studentId?: Maybe<Array<Scalars['Int']>>;
};

export enum GroupOrderField {
  Id = 'ID',
  ClassroomId = 'CLASSROOM_ID',
  GroupCategoryId = 'GROUP_CATEGORY_ID',
  Name = 'NAME'
}

export type GroupUnenrollmentInput = {
  groupId: Scalars['Int'];
  studentId: Scalars['Int'];
};

export type GroupUpdateInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupUpsertInput = {
  id?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  groupCategory?: Maybe<GroupCategoryUpsertInput>;
  name: Scalars['String'];
};

export type GroupWhereInput = {
  id?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['Int']>;
  classroomId?: Maybe<Scalars['Int']>;
  groupCategoryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type GroupsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<GroupOrderField>;
};

export type GroupsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  classroomId?: Maybe<Array<Scalars['Int']>>;
  groupCategoryId?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
};



export type License = {
  __typename?: 'License';
  id: Scalars['Int'];
  licenseTypeId: Scalars['Int'];
  licenseType: LicenseType;
  orderItemId: Scalars['Int'];
  orderItem?: Maybe<OrderItem>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  product?: Maybe<Product>;
  productId: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  manualAssignment?: Maybe<Scalars['Boolean']>;
  siteLicense?: Maybe<SiteLicense>;
  siteLicenseId?: Maybe<Scalars['Int']>;
  student?: Maybe<Student>;
  studentId?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
  dateUsed?: Maybe<Scalars['DateTime']>;
  dateUpdatedAssignment?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  dateExpiration: Scalars['DateTime'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export enum LicenseAction {
  Assign = 'ASSIGN',
  Unassign = 'UNASSIGN'
}

export type LicenseActionRequest = {
  __typename?: 'LicenseActionRequest';
  action?: Maybe<LicenseAction>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  gradeLevel?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignUpdates>;
};

export type LicenseAssignInput = {
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  productCurriculum?: Maybe<ProductIdentifierInput>;
  updates?: Maybe<LicenseAssignmentUpdateInput>;
};

export type LicenseAssignRequest = {
  __typename?: 'LicenseAssignRequest';
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  gradeLevel?: Maybe<Scalars['String']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignUpdates>;
};

export type LicenseAssignUpdates = {
  __typename?: 'LicenseAssignUpdates';
  dateExpiration?: Maybe<Scalars['DateTime']>;
  dateUsed?: Maybe<Scalars['DateTime']>;
  organizationId?: Maybe<Scalars['Int']>;
};

export type LicenseAssignmentUpdateInput = {
  dateExpiration?: Maybe<Scalars['DateTime']>;
  dateUsed?: Maybe<Scalars['DateTime']>;
  manualAssignment?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['Int']>;
};

export type LicenseExpirationInput = {
  gracePeriodEndDate: Scalars['DateTime'];
  unlockDate: Scalars['DateTime'];
};

export enum LicenseOrderField {
  Id = 'ID',
  DateCreated = 'DATE_CREATED',
  DateExpiration = 'DATE_EXPIRATION',
  DateUpdatedAssignment = 'DATE_UPDATED_ASSIGNMENT',
  DateUpdated = 'DATE_UPDATED',
  OrderItemId = 'ORDER_ITEM_ID',
  OrganizationId = 'ORGANIZATION_ID',
  ProductId = 'PRODUCT_ID',
  ProductCurriculumId = 'PRODUCT_CURRICULUM_ID',
  StudentId = 'STUDENT_ID',
  UserId = 'USER_ID'
}

export enum LicenseStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Removed = 'REMOVED'
}

export enum LicenseType {
  Full = 'FULL',
  MultiYear = 'MULTI_YEAR',
  Renewal = 'RENEWAL',
  AddOn = 'ADD_ON',
  Prorated = 'PRORATED',
  Trial = 'TRIAL',
  Workshop = 'WORKSHOP',
  Employee = 'EMPLOYEE',
  Overage = 'OVERAGE'
}

export type LicenseUpdateInput = {
  dateExpiration?: Maybe<Scalars['DateTime']>;
  expiration?: Maybe<LicenseExpirationInput>;
  orderItemId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
};

export type LicenseUsageWhereInput = {
  product?: Maybe<Array<ProductIdentifierInput>>;
  productCurriculum?: Maybe<Array<ProductIdentifierInput>>;
  productFamily?: Maybe<Array<ProductIdentifierInput>>;
};

export type LicenseWhereInput = {
  id: Scalars['Int'];
  includeRemoved?: Maybe<Scalars['Boolean']>;
};

export type LicensesMastercodeWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
};

export type LicensesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<LicenseOrderField>;
};

export type LicensesOrderWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  orderNumber?: Maybe<Array<Scalars['String']>>;
  orderNumber_contains?: Maybe<Scalars['String']>;
  ecmsOrderNumber?: Maybe<Array<Scalars['String']>>;
  ecmsOrderNumber_contains?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<LicensesOrderWhereInput>>;
  OR?: Maybe<Array<LicensesOrderWhereInput>>;
};

export type LicensesOrganizationWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
};

export type LicensesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  assigned?: Maybe<Scalars['Boolean']>;
  assigneeType?: Maybe<AssigneeType>;
  expired?: Maybe<Scalars['Boolean']>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  licenseType?: Maybe<Array<LicenseType>>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  organization?: Maybe<LicensesOrganizationWhereInput>;
  order?: Maybe<LicensesOrderWhereInput>;
  mastercode?: Maybe<LicensesMastercodeWhereInput>;
  product?: Maybe<Array<ProductIdentifierInput>>;
  productCurriculum?: Maybe<Array<ProductIdentifierInput>>;
  productFamily?: Maybe<Array<ProductIdentifierInput>>;
  siteLicenseId?: Maybe<Array<Scalars['Int']>>;
  status?: Maybe<Array<LicenseStatus>>;
  studentId?: Maybe<Array<Scalars['Int']>>;
  userId?: Maybe<Array<Scalars['Int']>>;
  AND?: Maybe<Array<LicensesWhereInput>>;
  OR?: Maybe<Array<LicensesWhereInput>>;
};

export enum Locale {
  EnUs = 'EN_US',
  EsUs = 'ES_US'
}

export type Mastercode = {
  __typename?: 'Mastercode';
  id: Scalars['Int'];
  code: Scalars['String'];
  ownerEmail?: Maybe<Scalars['String']>;
  parentMastercode?: Maybe<Mastercode>;
  parentMastercodeId?: Maybe<Scalars['Int']>;
  orderItems?: Maybe<Array<OrderItem>>;
  transferHistory?: Maybe<Array<MastercodeTransferHistory>>;
  status?: Maybe<MastercodeStatus>;
  dateGracePeriodEnd: Scalars['DateTime'];
  dateScheduledUnlock?: Maybe<Scalars['DateTime']>;
  dateUnlocked?: Maybe<Scalars['DateTime']>;
  dateExpired?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export enum MastercodeOrderField {
  Id = 'ID',
  Code = 'CODE',
  OwnerEmail = 'OWNER_EMAIL',
  DateCreated = 'DATE_CREATED',
  DateUnlocked = 'DATE_UNLOCKED',
  DateRemoved = 'DATE_REMOVED',
  DateScheduledUnlock = 'DATE_SCHEDULED_UNLOCK'
}

export type MastercodeOrderItemsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  licenseTypeId?: Maybe<Array<Scalars['Int']>>;
  licenseType?: Maybe<Array<LicenseType>>;
};

export type MastercodeOrdersWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  psrentOrderId?: Maybe<Array<Scalars['Int']>>;
  orderNumber?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Array<Scalars['String']>>;
  userId?: Maybe<Array<Scalars['Int']>>;
};

export type MastercodeOrganizationsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
};

export enum MastercodeStatus {
  Unlocked = 'UNLOCKED',
  Expired = 'EXPIRED',
  Removed = 'REMOVED',
  Locked = 'LOCKED',
  Scheduled = 'SCHEDULED'
}

export type MastercodeTransferHistoriesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  newOwnerEmail?: Maybe<Array<Scalars['String']>>;
  previousOwnerEmail?: Maybe<Array<Scalars['String']>>;
  mastercodeId?: Maybe<Array<Scalars['Int']>>;
};

export type MastercodeTransferHistory = {
  __typename?: 'MastercodeTransferHistory';
  id: Scalars['Int'];
  mastercodeId: Scalars['Int'];
  previousOwnerEmail: Scalars['String'];
  newOwnerEmail: Scalars['String'];
  dateTransferred: Scalars['DateTime'];
  mastercode?: Maybe<Mastercode>;
};

export enum MastercodeTransferHistoryOrderField {
  Id = 'ID',
  MastercodeId = 'MASTERCODE_ID',
  NewOwnerEmail = 'NEW_OWNER_EMAIL',
  PreviousOwnerEmail = 'PREVIOUS_OWNER_EMAIL',
  DateTranserred = 'DATE_TRANSERRED'
}

export type MastercodeTransferHistoryOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<MastercodeTransferHistoryOrderField>;
};

export type MastercodeTransferHistoryWhereInput = {
  id: Scalars['Int'];
};

export type MastercodeTransferInput = {
  ownerEmail: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type MastercodeUpdateInput = {
  userId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  dateExpiration?: Maybe<Scalars['DateTime']>;
};

export type MastercodeWhereInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  ownerEmail?: Maybe<Scalars['String']>;
};

export type MastercodesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<MastercodeOrderField>;
};

export type MastercodesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
  expired?: Maybe<Scalars['Boolean']>;
  orderId?: Maybe<Array<Scalars['Int']>>;
  ownerEmail?: Maybe<Array<Scalars['String']>>;
  ownerEmail_contains?: Maybe<Scalars['String']>;
  parentMastercodeId?: Maybe<Array<Scalars['Int']>>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  unlocked?: Maybe<Scalars['Boolean']>;
  orders?: Maybe<MastercodeOrdersWhereInput>;
  orderItems?: Maybe<MastercodeOrderItemsWhereInput>;
  organizations?: Maybe<MastercodeOrganizationsWhereInput>;
  products?: Maybe<ProductsWhereInput>;
  status?: Maybe<Array<MastercodeStatus>>;
};

export type Media = {
  __typename?: 'Media';
  src: Scalars['String'];
  mediaType: MediaType;
};

export enum MediaType {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type Mutation = {
  __typename?: 'Mutation';
  createStudentAssessment?: Maybe<StudentAssessment>;
  updateStudentAssessment?: Maybe<StudentAssessment>;
  removeStudentAssessment?: Maybe<StudentAssessment>;
  removeStudentAssessments?: Maybe<BatchMutationResult>;
  createStudentAssessmentOutcome?: Maybe<StudentAssessmentOutcome>;
  updateStudentAssessmentOutcome?: Maybe<StudentAssessmentOutcome>;
  removeStudentAssessmentOutcome?: Maybe<StudentAssessmentOutcome>;
  removeStudentAssessmentOutcomes: BatchMutationResult;
  createStudentChecklist?: Maybe<StudentChecklist>;
  updateStudentChecklist?: Maybe<StudentChecklist>;
  removeStudentChecklist?: Maybe<StudentChecklist>;
  removeStudentChecklists: BatchMutationResult;
  createStudentChecklistOutcome?: Maybe<StudentChecklistOutcome>;
  updateStudentChecklistOutcome?: Maybe<StudentChecklistOutcome>;
  removeStudentChecklistOutcome?: Maybe<StudentChecklistOutcome>;
  removeStudentChecklistOutcomes: BatchMutationResult;
  _dummyCore?: Maybe<Scalars['Boolean']>;
  /**
   * - Required privileges:
   *   - academic-session.create
   */
  createAcademicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  updateAcademicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  updateAcademicSessions?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  removeAcademicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  removeAcademicSessions?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  archiveClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  archiveClassrooms?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.create
   */
  createClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  removeClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  removeClassrooms?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  updateClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  updateClassrooms?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated Field no longer supported
   */
  createClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated Field no longer supported
   */
  updateClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated Field no longer supported
   */
  updateClassroomSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  saveClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  saveClassroomSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  removeClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  removeClassroomSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - contact.create
   */
  createContact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  updateContact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  updateContacts: BatchMutationResult;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeContact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeContacts: BatchMutationResult;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeStudentFromContact: BatchMutationResult;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  enroll?: Maybe<Array<Maybe<Enrollment>>>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  unenroll?: Maybe<BatchMutationResult>;
  createFeatureToggle?: Maybe<FeatureToggle>;
  updateFeatureToggle?: Maybe<FeatureToggle>;
  updateFeatureToggles?: Maybe<BatchMutationResult>;
  removeFeatureToggle?: Maybe<FeatureToggle>;
  removeFeatureToggles?: Maybe<BatchMutationResult>;
  createGroup?: Maybe<Group>;
  updateGroup?: Maybe<Group>;
  removeGroup?: Maybe<Group>;
  removeGroups: BatchMutationResult;
  enrollGroup?: Maybe<Array<GroupEnrollment>>;
  unenrollGroup?: Maybe<BatchMutationResult>;
  bulkGroupEnrollmentAction?: Maybe<Array<BulkGroupEnrollmentActionResult>>;
  /**
   * - Required privileges:
   *   - organization.create
   */
  createOrganization?: Maybe<Organization>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  updateOrganization?: Maybe<Organization>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  updateOrganizations?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  removeOrganization?: Maybe<Organization>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  removeOrganizations?: Maybe<BatchMutationResult>;
  saveOrganizationSetting?: Maybe<OrganizationSetting>;
  saveOrganizationSettings?: Maybe<BatchMutationResult>;
  removeOrganizationSetting?: Maybe<OrganizationSetting>;
  removeOrganizationSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.create
   */
  createStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student.create
   */
  createStudents: Array<Maybe<Student>>;
  /**
   * - Required privileges:
   *   - student.write
   */
  updateStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student.write
   */
  updateStudents?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  removeStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student.write
   */
  removeStudents?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  transferStudent?: Maybe<Enrollment>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated Field no longer supported
   */
  createStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated Field no longer supported
   */
  updateStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated Field no longer supported
   */
  updateStudentSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  saveStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  saveStudentSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  removeStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  removeStudentSettings?: Maybe<BatchMutationResult>;
  saveToursSettings: Array<Maybe<TourSettings>>;
  /**
   * - Required privileges:
   *   - user.create
   */
  createUser?: Maybe<User>;
  updateMe?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.write
   */
  updateUser?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.write
   */
  updateUsers?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user.write
   */
  removeUser?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.write
   */
  removeUsers?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated Field no longer supported
   */
  createUserSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated Field no longer supported
   */
  updateUserSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated Field no longer supported
   */
  updateUserSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  saveUserSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  saveUserSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  removeUserSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  removeUserSettings?: Maybe<BatchMutationResult>;
  _dummyFulfillment?: Maybe<Scalars['Boolean']>;
  scheduleUnlockMastercode: Mastercode;
  scheduleUnlockOrderMastercodes: BatchMutationResult;
  transferMastercode: Mastercode;
  transferOrderMastercodes: BatchMutationResult;
  unlockMastercode: ProvisioningResult;
  unlockOrderMastercodes: ProvisioningResult;
  extendMastercode: Mastercode;
  expireMastercode: Mastercode;
  moveMastercode: Mastercode;
  _dummyLicenseManager?: Maybe<Scalars['Boolean']>;
  assignAvailableLicense?: Maybe<License>;
  assignLicense?: Maybe<License>;
  bulkAssignAvailableLicenses: Array<BulkAssignResult>;
  bulkLicenseAction: Array<BulkLicenseActionResult>;
  swapLicenses: Array<Maybe<License>>;
  unassignLicense?: Maybe<License>;
  unassignLicenses?: Maybe<BatchMutationResult>;
  updateLicense?: Maybe<License>;
  updateLicenses?: Maybe<BatchMutationResult>;
  updateSiteLicense?: Maybe<SiteLicense>;
  updateSiteLicenses?: Maybe<BatchMutationResult>;
};


export type MutationCreateStudentAssessmentArgs = {
  data: StudentAssessmentCreateInput;
};


export type MutationUpdateStudentAssessmentArgs = {
  where: StudentAssessmentWhereInput;
  data: StudentAssessmentUpdateInput;
};


export type MutationRemoveStudentAssessmentArgs = {
  where: StudentAssessmentWhereInput;
};


export type MutationRemoveStudentAssessmentsArgs = {
  where: StudentAssessmentsWhereInput;
};


export type MutationCreateStudentAssessmentOutcomeArgs = {
  data: StudentAssessmentOutcomeCreateInput;
};


export type MutationUpdateStudentAssessmentOutcomeArgs = {
  where: StudentAssessmentOutcomeWhereInput;
  data: StudentAssessmentOutcomeUpdateInput;
};


export type MutationRemoveStudentAssessmentOutcomeArgs = {
  where: StudentAssessmentOutcomeWhereInput;
};


export type MutationRemoveStudentAssessmentOutcomesArgs = {
  where: StudentAssessmentOutcomesWhereInput;
};


export type MutationCreateStudentChecklistArgs = {
  data: StudentChecklistCreateInput;
};


export type MutationUpdateStudentChecklistArgs = {
  where: StudentChecklistWhereInput;
  data: StudentChecklistUpdateInput;
};


export type MutationRemoveStudentChecklistArgs = {
  where: StudentChecklistWhereInput;
};


export type MutationRemoveStudentChecklistsArgs = {
  where: StudentChecklistsWhereInput;
};


export type MutationCreateStudentChecklistOutcomeArgs = {
  data: StudentChecklistOutcomeCreateInput;
};


export type MutationUpdateStudentChecklistOutcomeArgs = {
  where: StudentChecklistOutcomeWhereInput;
  data: StudentChecklistOutcomeUpdateInput;
};


export type MutationRemoveStudentChecklistOutcomeArgs = {
  where: StudentChecklistOutcomeWhereInput;
};


export type MutationRemoveStudentChecklistOutcomesArgs = {
  where: StudentChecklistOutcomesWhereInput;
};


export type MutationCreateAcademicSessionArgs = {
  data: AcademicSessionCreateInput;
};


export type MutationUpdateAcademicSessionArgs = {
  where: AcademicSessionWhereInput;
  data: AcademicSessionUpdateInput;
};


export type MutationUpdateAcademicSessionsArgs = {
  where: AcademicSessionsWhereInput;
  data: AcademicSessionsUpdateInput;
};


export type MutationRemoveAcademicSessionArgs = {
  where: AcademicSessionWhereInput;
};


export type MutationRemoveAcademicSessionsArgs = {
  where: AcademicSessionsWhereInput;
};


export type MutationArchiveClassroomArgs = {
  where: ClassroomWhereInput;
};


export type MutationArchiveClassroomsArgs = {
  where: ClassroomsWhereInput;
};


export type MutationCreateClassroomArgs = {
  data: ClassroomCreateInput;
};


export type MutationRemoveClassroomArgs = {
  where: ClassroomWhereInput;
};


export type MutationRemoveClassroomsArgs = {
  where: ClassroomsWhereInput;
};


export type MutationUpdateClassroomArgs = {
  where: ClassroomWhereInput;
  data: ClassroomUpdateInput;
};


export type MutationUpdateClassroomsArgs = {
  where: ClassroomsWhereInput;
  data: ClassroomsUpdateInput;
};


export type MutationCreateClassroomSettingArgs = {
  data: ClassroomSettingCreateInput;
};


export type MutationUpdateClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
  data: ClassroomSettingUpdateInput;
};


export type MutationUpdateClassroomSettingsArgs = {
  where: ClassroomSettingsWhereInput;
  data: ClassroomSettingsUpdateInput;
};


export type MutationSaveClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
  value: Scalars['JSON'];
};


export type MutationSaveClassroomSettingsArgs = {
  where: ClassroomSettingsWhereInput;
  value: Scalars['JSON'];
};


export type MutationRemoveClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
};


export type MutationRemoveClassroomSettingsArgs = {
  where: ClassroomSettingsWhereInput;
};


export type MutationCreateContactArgs = {
  data: ContactInput;
};


export type MutationUpdateContactArgs = {
  where: ContactWhereInput;
  data: ContactUpdateInput;
};


export type MutationUpdateContactsArgs = {
  where: ContactsWhereInput;
  data: ContactUpdateInput;
};


export type MutationRemoveContactArgs = {
  where: ContactWhereInput;
};


export type MutationRemoveContactsArgs = {
  where: ContactsWhereInput;
};


export type MutationRemoveStudentFromContactArgs = {
  data: ContactStudentRemoveInput;
};


export type MutationEnrollArgs = {
  classroomId: Scalars['Int'];
  studentIds?: Maybe<Array<Scalars['Int']>>;
  userEnrollments?: Maybe<Array<UserEnrollmentInput>>;
};


export type MutationUnenrollArgs = {
  classroomId: Scalars['Int'];
  studentIds?: Maybe<Array<Scalars['Int']>>;
  userEnrollments?: Maybe<Array<UserEnrollmentInput>>;
};


export type MutationCreateFeatureToggleArgs = {
  data: FeatureToggleInput;
};


export type MutationUpdateFeatureToggleArgs = {
  where: FeatureToggleWhereInput;
  data: FeatureToggleUpdateInput;
};


export type MutationUpdateFeatureTogglesArgs = {
  where: FeatureTogglesWhereInput;
  data: FeatureToggleUpdateInput;
};


export type MutationRemoveFeatureToggleArgs = {
  where: FeatureToggleWhereInput;
};


export type MutationRemoveFeatureTogglesArgs = {
  where: FeatureTogglesWhereInput;
};


export type MutationCreateGroupArgs = {
  data: GroupCreateInput;
};


export type MutationUpdateGroupArgs = {
  data: GroupUpdateInput;
};


export type MutationRemoveGroupArgs = {
  where: GroupWhereInput;
};


export type MutationRemoveGroupsArgs = {
  where: GroupsWhereInput;
};


export type MutationEnrollGroupArgs = {
  groupId: Scalars['Int'];
  studentIds: Array<Scalars['Int']>;
};


export type MutationUnenrollGroupArgs = {
  groupId: Scalars['Int'];
  studentIds: Array<Scalars['Int']>;
};


export type MutationBulkGroupEnrollmentActionArgs = {
  data: Array<BulkGroupEnrollmentActionInput>;
};


export type MutationCreateOrganizationArgs = {
  data: OrganizationCreateInput;
};


export type MutationUpdateOrganizationArgs = {
  where: OrganizationWhereInput;
  data: OrganizationUpdateInput;
};


export type MutationUpdateOrganizationsArgs = {
  where: OrganizationsWhereInput;
  data: OrganizationsUpdateInput;
};


export type MutationRemoveOrganizationArgs = {
  where: OrganizationWhereInput;
};


export type MutationRemoveOrganizationsArgs = {
  where: OrganizationsWhereInput;
};


export type MutationSaveOrganizationSettingArgs = {
  where: OrganizationSettingWhereInput;
  value: Scalars['JSON'];
};


export type MutationSaveOrganizationSettingsArgs = {
  where: OrganizationSettingsWhereInput;
  value: Scalars['JSON'];
};


export type MutationRemoveOrganizationSettingArgs = {
  where: OrganizationSettingWhereInput;
};


export type MutationRemoveOrganizationSettingsArgs = {
  where: OrganizationSettingsWhereInput;
};


export type MutationCreateStudentArgs = {
  data: StudentCreateInput;
};


export type MutationCreateStudentsArgs = {
  data: Array<StudentCreateInput>;
};


export type MutationUpdateStudentArgs = {
  where: StudentWhereInput;
  data: StudentUpdateInput;
};


export type MutationUpdateStudentsArgs = {
  where: StudentsWhereInput;
  data: StudentsUpdateInput;
};


export type MutationRemoveStudentArgs = {
  where: StudentWhereInput;
};


export type MutationRemoveStudentsArgs = {
  where: StudentsWhereInput;
};


export type MutationTransferStudentArgs = {
  where: TransferStudentWhereInput;
  data: TransferStudentInput;
};


export type MutationCreateStudentSettingArgs = {
  data: StudentSettingCreateInput;
};


export type MutationUpdateStudentSettingArgs = {
  where: StudentSettingWhereInput;
  data: StudentSettingUpdateInput;
};


export type MutationUpdateStudentSettingsArgs = {
  where: StudentSettingsWhereInput;
  data: StudentSettingsUpdateInput;
};


export type MutationSaveStudentSettingArgs = {
  where: StudentSettingWhereInput;
  value: Scalars['JSON'];
};


export type MutationSaveStudentSettingsArgs = {
  where: StudentSettingsWhereInput;
  value: Scalars['JSON'];
};


export type MutationRemoveStudentSettingArgs = {
  where: StudentSettingWhereInput;
};


export type MutationRemoveStudentSettingsArgs = {
  where: StudentSettingsWhereInput;
};


export type MutationSaveToursSettingsArgs = {
  data: SaveToursSettingsInput;
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
  upsert?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateMeArgs = {
  data: UserUpdateInput;
};


export type MutationUpdateUserArgs = {
  where: UserWhereInput;
  data: UserUpdateInput;
};


export type MutationUpdateUsersArgs = {
  where: UsersWhereInput;
  data: UsersUpdateInput;
};


export type MutationRemoveUserArgs = {
  where: UserWhereInput;
};


export type MutationRemoveUsersArgs = {
  where: UsersWhereInput;
};


export type MutationCreateUserSettingArgs = {
  data: UserSettingCreateInput;
};


export type MutationUpdateUserSettingArgs = {
  where: UserSettingWhereInput;
  data: UserSettingUpdateInput;
};


export type MutationUpdateUserSettingsArgs = {
  where: UserSettingsWhereInput;
  data: UserSettingsUpdateInput;
};


export type MutationSaveUserSettingArgs = {
  where: UserSettingWhereInput;
  value: Scalars['JSON'];
};


export type MutationSaveUserSettingsArgs = {
  where: UserSettingsWhereInput;
  value: Scalars['JSON'];
};


export type MutationRemoveUserSettingArgs = {
  where: UserSettingWhereInput;
};


export type MutationRemoveUserSettingsArgs = {
  where: UserSettingsWhereInput;
};


export type MutationScheduleUnlockMastercodeArgs = {
  where: MastercodeWhereInput;
  date: Scalars['DateTime'];
};


export type MutationScheduleUnlockOrderMastercodesArgs = {
  where: OrderWhereInput;
  date: Scalars['DateTime'];
};


export type MutationTransferMastercodeArgs = {
  where: MastercodeWhereInput;
  data: MastercodeTransferInput;
};


export type MutationTransferOrderMastercodesArgs = {
  where: OrderWhereInput;
  data: MastercodeTransferInput;
};


export type MutationUnlockMastercodeArgs = {
  where: MastercodeWhereInput;
};


export type MutationUnlockOrderMastercodesArgs = {
  where: OrderWhereInput;
};


export type MutationExtendMastercodeArgs = {
  where: MastercodeWhereInput;
  data: MastercodeUpdateInput;
};


export type MutationExpireMastercodeArgs = {
  where: MastercodeWhereInput;
  data?: Maybe<MastercodeUpdateInput>;
};


export type MutationMoveMastercodeArgs = {
  where: MastercodeWhereInput;
  data: MastercodeUpdateInput;
};


export type MutationAssignAvailableLicenseArgs = {
  where: AssignAvailableLicenseWhereInput;
  data: AssignAvailableLicenseInput;
};


export type MutationAssignLicenseArgs = {
  where: LicenseWhereInput;
  data: LicenseAssignInput;
};


export type MutationBulkAssignAvailableLicensesArgs = {
  where?: Maybe<BulkAssignAvailableWhereInput>;
  data: Array<BulkAssignAvailableLicenseInput>;
};


export type MutationBulkLicenseActionArgs = {
  where?: Maybe<BulkLicenseActionWhereInput>;
  data: Array<BulkLicenseActionInput>;
};


export type MutationSwapLicensesArgs = {
  where: SwapLicensesWhereInput;
  data: SwapLicensesInput;
};


export type MutationUnassignLicenseArgs = {
  where: LicenseWhereInput;
};


export type MutationUnassignLicensesArgs = {
  where: LicensesWhereInput;
};


export type MutationUpdateLicenseArgs = {
  where: LicenseWhereInput;
  data: LicenseUpdateInput;
};


export type MutationUpdateLicensesArgs = {
  where: LicensesWhereInput;
  data: LicenseUpdateInput;
};


export type MutationUpdateSiteLicenseArgs = {
  where: SiteLicenseWhereInput;
  data: SiteLicenseUpdateInput;
};


export type MutationUpdateSiteLicensesArgs = {
  where: SiteLicensesWhereInput;
  data: SiteLicenseUpdateInput;
};

export type Observation = {
  __typename?: 'Observation';
  id: Scalars['Int'];
  domainId: Scalars['Int'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  pointsPossible: Scalars['Int'];
  domain: Domain;
};

export type Offset = {
  __typename?: 'Offset';
  top?: Maybe<Scalars['Int']>;
  left?: Maybe<Scalars['Int']>;
  bottom?: Maybe<Scalars['Int']>;
  right?: Maybe<Scalars['Int']>;
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['Int'];
  orderNumber?: Maybe<Scalars['String']>;
  ecmsOrderNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  cmsCustomerNumber?: Maybe<Scalars['String']>;
  crmNumber?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  parentOrder?: Maybe<Order>;
  parentOrderId?: Maybe<Scalars['Int']>;
  dateOrdered: Scalars['DateTime'];
  dateFulfilled?: Maybe<Scalars['DateTime']>;
  mastercodes?: Maybe<Array<Mastercode>>;
  orderItems?: Maybe<Array<OrderItem>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
};


export type OrderMastercodesArgs = {
  where?: Maybe<MastercodesWhereInput>;
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderItem = {
  __typename?: 'OrderItem';
  id: Scalars['Int'];
  order: Order;
  orderId: Scalars['Int'];
  lineId?: Maybe<Scalars['Int']>;
  lineNumber?: Maybe<Scalars['Int']>;
  mastercode?: Maybe<Mastercode>;
  mastercodeId: Scalars['Int'];
  product?: Maybe<Product>;
  productId: Scalars['Int'];
  licenseCount: Scalars['Int'];
  licenseTypeId: Scalars['Int'];
  licenseType: LicenseType;
  licenses?: Maybe<Array<License>>;
  siteLicense?: Maybe<SiteLicense>;
  multiyearTerm?: Maybe<Scalars['Int']>;
  siteLicenseRangeMin?: Maybe<Scalars['Int']>;
  siteLicenseRangeMax?: Maybe<Scalars['Int']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type OrderItemProvisioningResult = {
  __typename?: 'OrderItemProvisioningResult';
  orderItem?: Maybe<OrderItem>;
  orderItemId: Scalars['Int'];
  dateExpiration?: Maybe<Scalars['DateTime']>;
  licenseCount: Scalars['Int'];
};

export enum OrderOrderField {
  Id = 'ID',
  DateCreated = 'DATE_CREATED',
  DateFulfilled = 'DATE_FULFILLED',
  DateOrdered = 'DATE_ORDERED',
  DateRemoved = 'DATE_REMOVED',
  OrderNumber = 'ORDER_NUMBER',
  Type = 'TYPE',
  WebstoreOrderNumber = 'WEBSTORE_ORDER_NUMBER'
}

export type OrderWhereInput = {
  id: Scalars['Int'];
  ownerEmail?: Maybe<Scalars['String']>;
};

export type OrdersOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<OrderOrderField>;
};

export type OrdersWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  completed?: Maybe<Scalars['Boolean']>;
  ecmsOrderNumber?: Maybe<Array<Scalars['String']>>;
  excludeTrialType?: Maybe<Scalars['Boolean']>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  mastercodeId?: Maybe<Array<Scalars['Int']>>;
  mastercode?: Maybe<Array<Scalars['String']>>;
  ownerEmail?: Maybe<Array<Scalars['String']>>;
  ownerEmail_contains?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Array<Scalars['String']>>;
  parentOrderNumber?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<ProductsWhereInput>;
  type?: Maybe<Array<Scalars['String']>>;
  type_contains?: Maybe<Scalars['String']>;
  userId?: Maybe<Array<Scalars['Int']>>;
  AND?: Maybe<Array<OrdersWhereInput>>;
  OR?: Maybe<Array<OrdersWhereInput>>;
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sisId?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['String']>;
  mdrNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: OrganizationType;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  ancestorOrganizations?: Maybe<Array<Maybe<Organization>>>;
  parentOrganization?: Maybe<Organization>;
  parentOrganizationId?: Maybe<Scalars['Int']>;
  organizationTypeId?: Maybe<Scalars['Int']>;
  rootOrganization?: Maybe<Organization>;
  subOrganizations?: Maybe<Array<Maybe<Organization>>>;
  academicSessions?: Maybe<Array<Maybe<AcademicSession>>>;
  classrooms?: Maybe<Array<Classroom>>;
  users?: Maybe<Array<UserOrganization>>;
  settings?: Maybe<Array<OrganizationSetting>>;
  stats: OrganizationStats;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  mastercodes?: Maybe<Array<Mastercode>>;
  licenses?: Maybe<Array<License>>;
  licenseUsage?: Maybe<Array<OrganizationLicenseUsage>>;
};


export type OrganizationAncestorOrganizationsArgs = {
  where?: Maybe<OrganizationsWhereInput>;
  maxHeight?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<OrganizationsOrderInput>;
};


export type OrganizationSubOrganizationsArgs = {
  where?: Maybe<OrganizationsWhereInput>;
  maxDepth?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<OrganizationsOrderInput>;
};


export type OrganizationAcademicSessionsArgs = {
  where?: Maybe<AcademicSessionsWhereInput>;
  orderBy?: Maybe<AcademicSessionsOrderInput>;
};


export type OrganizationUsersArgs = {
  where?: Maybe<UserOrganizationWhereInput>;
};


export type OrganizationSettingsArgs = {
  where?: Maybe<OrganizationSettingsWhereInput>;
  orderBy?: Maybe<OrganizationSettingsOrderInput>;
};


export type OrganizationMastercodesArgs = {
  where?: Maybe<MastercodesWhereInput>;
  orderBy?: Maybe<MastercodesOrderInput>;
};


export type OrganizationLicensesArgs = {
  where?: Maybe<LicensesWhereInput>;
  orderBy?: Maybe<LicensesOrderInput>;
};


export type OrganizationLicenseUsageArgs = {
  where?: Maybe<LicenseUsageWhereInput>;
};

export type OrganizationCreateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['String']>;
  mdrNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: OrganizationType;
  parentOrganizationId?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type OrganizationLicenseUsage = {
  __typename?: 'OrganizationLicenseUsage';
  organizationId: Scalars['Int'];
  product: Product;
  productId: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  siteLicensed: Scalars['Boolean'];
  expiringCount: Scalars['Int'];
  availableCount: Scalars['Int'];
  assignedCount: Scalars['Int'];
  classroomAssignedCount: Scalars['Int'];
  inUseCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  overageStats?: Maybe<OrganizationLicenseUsageOverageStats>;
};

export type OrganizationLicenseUsageOverageStats = {
  __typename?: 'OrganizationLicenseUsageOverageStats';
  availableCount: Scalars['Int'];
  assignedCount: Scalars['Int'];
  expiringCount: Scalars['Int'];
  overageLimitCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export enum OrganizationOrderField {
  Id = 'ID',
  SourceKindId = 'SOURCE_KIND_ID',
  SourceId = 'SOURCE_ID',
  Name = 'NAME',
  OrganizationTypeId = 'ORGANIZATION_TYPE_ID',
  ParentOrganizationId = 'PARENT_ORGANIZATION_ID'
}

export type OrganizationPrivilege = {
  __typename?: 'OrganizationPrivilege';
  id: Scalars['Int'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  public: Scalars['Boolean'];
};

export enum OrganizationPrivilegeOrderField {
  Id = 'ID',
  Name = 'NAME'
}

export type OrganizationPrivilegeWhereInput = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type OrganizationPrivilegesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<OrganizationPrivilegeOrderField>;
};

export type OrganizationPrivilegesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
};

export type OrganizationRole = {
  __typename?: 'OrganizationRole';
  id: Scalars['Int'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  classification: OrganizationRoleClassification;
  appId?: Maybe<Scalars['Int']>;
  app?: Maybe<App>;
  organizationId?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  privileges?: Maybe<Array<Maybe<OrganizationPrivilege>>>;
  public: Scalars['Boolean'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum OrganizationRoleClassification {
  Admin = 'ADMIN',
  Faculty = 'FACULTY',
  Auditor = 'AUDITOR'
}

export enum OrganizationRoleOrderField {
  Id = 'ID',
  Name = 'NAME',
  App = 'APP',
  Organization = 'ORGANIZATION'
}

export type OrganizationRoleWhereInput = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type OrganizationRolesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<OrganizationRoleOrderField>;
};

export type OrganizationRolesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  classification?: Maybe<Array<OrganizationRoleClassification>>;
};

export type OrganizationSetting = {
  __typename?: 'OrganizationSetting';
  id: Scalars['Int'];
  appId?: Maybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  app?: Maybe<App>;
  organization: Organization;
};

export enum OrganizationSettingOrderField {
  AppId = 'APP_ID',
  Setting = 'SETTING',
  OrganizationId = 'ORGANIZATION_ID'
}

export type OrganizationSettingWhereInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  setting: Scalars['String'];
};

export type OrganizationSettingsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<OrganizationSettingOrderField>;
};

export type OrganizationSettingsWhereInput = {
  appId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  appName?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  setting?: Maybe<Array<Scalars['String']>>;
};

export type OrganizationStats = {
  __typename?: 'OrganizationStats';
  classroomCount: Scalars['Int'];
  classroomStudentCount: Scalars['Int'];
  classroomUserCount: Scalars['Int'];
  studentCount: Scalars['Int'];
  enrolledStudentCount: Scalars['Int'];
  userCount: Scalars['Int'];
};

export enum OrganizationType {
  UserGroup = 'USER_GROUP',
  Department = 'DEPARTMENT',
  School = 'SCHOOL',
  District = 'DISTRICT',
  Local = 'LOCAL',
  State = 'STATE',
  National = 'NATIONAL'
}

export type OrganizationUpdateInput = {
  externalId?: Maybe<ExternalIdUpdateInput>;
  sisId?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['String']>;
  mdrNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<OrganizationType>;
  parentOrganizationId?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type OrganizationWhereInput = {
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<ExternalIdInput>;
};

export type OrganizationsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<OrganizationOrderField>;
};

export type OrganizationsUpdateInput = {
  type?: Maybe<OrganizationType>;
  parentOrganizationId?: Maybe<Scalars['Int']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type OrganizationsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  isRootOrganization?: Maybe<Scalars['Boolean']>;
  mdrNumber?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
  name_contains?: Maybe<Scalars['String']>;
  nsecId?: Maybe<Array<Scalars['String']>>;
  parentOrganization?: Maybe<OrganizationsWhereInput>;
  sisId?: Maybe<Array<Scalars['String']>>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  type?: Maybe<Array<OrganizationType>>;
  AND?: Maybe<Array<OrganizationsWhereInput>>;
  OR?: Maybe<Array<OrganizationsWhereInput>>;
};

export type PagingInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export enum Placement {
  Above = 'ABOVE',
  Below = 'BELOW',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type Position = {
  __typename?: 'Position';
  offset?: Maybe<Offset>;
  placement?: Maybe<Placement>;
};

export type Product = {
  __typename?: 'Product';
  id: Scalars['Int'];
  code: Scalars['String'];
  name: Scalars['String'];
  type: ProductType;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  defaultGradeLevel?: Maybe<Array<Scalars['String']>>;
  trialAvailable: Scalars['Boolean'];
  curriculums?: Maybe<Array<ProductCurriculum>>;
  family: ProductFamily;
  iconUrl?: Maybe<Scalars['String']>;
  bannerUrl?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type ProductBundle = {
  __typename?: 'ProductBundle';
  id: Scalars['Int'];
  code: Scalars['String'];
  name: Scalars['String'];
  products: Array<Maybe<Product>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum ProductBundleOrderField {
  Id = 'ID',
  Code = 'CODE',
  Name = 'NAME',
  DateCreated = 'DATE_CREATED',
  DateUpdated = 'DATE_UPDATED'
}

export type ProductBundleWhereInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
};

export type ProductBundlesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ProductBundleOrderField>;
};

export type ProductBundlesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
};

export type ProductCurriculum = {
  __typename?: 'ProductCurriculum';
  id: Scalars['Int'];
  code: Scalars['String'];
  name: Scalars['String'];
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  defaultGradeLevel?: Maybe<Array<Scalars['String']>>;
  trialAvailable: Scalars['Boolean'];
  productId: Scalars['Int'];
  product?: Maybe<Product>;
  iconUrl?: Maybe<Scalars['String']>;
  bannerUrl?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum ProductCurriculumOrderField {
  Id = 'ID',
  Code = 'CODE',
  Name = 'NAME',
  TrialAvailable = 'TRIAL_AVAILABLE',
  ProductId = 'PRODUCT_ID'
}

export type ProductCurriculumWhereInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
};

export type ProductCurriculumsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ProductCurriculumOrderField>;
};

export type ProductCurriculumsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  trialAvailable?: Maybe<Array<Scalars['Boolean']>>;
  type?: Maybe<Array<ProductType>>;
  product?: Maybe<ProductsWhereInput>;
};

export type ProductFamiliesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ProductFamilyOrderField>;
};

export type ProductFamiliesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
  pliManaged?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Array<ProductType>>;
};

export type ProductFamily = {
  __typename?: 'ProductFamily';
  id: Scalars['Int'];
  code: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  products: Array<Maybe<Product>>;
  types: Array<Maybe<ProductType>>;
  iconUrl?: Maybe<Scalars['String']>;
  bannerUrl?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  pliManaged?: Maybe<Scalars['Boolean']>;
  accessDetails?: Maybe<ProductFamilyAccessDetails>;
  purchaseDetails?: Maybe<ProductFamilyPurchaseDetails>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type ProductFamilyAccessDetails = {
  __typename?: 'ProductFamilyAccessDetails';
  bannerUrl: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  iosUrl?: Maybe<Scalars['String']>;
};

export enum ProductFamilyOrderField {
  Id = 'ID',
  Code = 'CODE',
  Name = 'NAME'
}

export type ProductFamilyPurchaseDetails = {
  __typename?: 'ProductFamilyPurchaseDetails';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ProductFamilyWhereInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
};

export type ProductIdentifierInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
};

export enum ProductOrderField {
  Id = 'ID',
  Code = 'CODE',
  Name = 'NAME',
  TrialAvailable = 'TRIAL_AVAILABLE',
  ProductFamilyId = 'PRODUCT_FAMILY_ID'
}

export enum ProductType {
  Student = 'STUDENT',
  User = 'USER'
}

export type ProductWhereInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
};

export type ProductsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<ProductOrderField>;
};

export type ProductsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  code?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Array<Scalars['String']>>;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  trialAvailable?: Maybe<Array<Scalars['Boolean']>>;
  type?: Maybe<Array<ProductType>>;
  productFamilyId?: Maybe<Array<Scalars['Int']>>;
};

export type ProvisioningResult = {
  __typename?: 'ProvisioningResult';
  success?: Maybe<Array<OrderItemProvisioningResult>>;
  fail?: Maybe<Array<OrderItemProvisioningResult>>;
};

export type Query = {
  __typename?: 'Query';
  assessment?: Maybe<Assessment>;
  assessments: Array<Assessment>;
  checklist?: Maybe<Checklist>;
  checklists: Array<Checklist>;
  domain?: Maybe<Domain>;
  domains: Array<Domain>;
  educatorPacket?: Maybe<EducatorPacket>;
  educatorPackets: Array<EducatorPacket>;
  assessmentReport?: Maybe<AssessmentReport>;
  assessmentReports: Array<AssessmentReport>;
  studentAssessment?: Maybe<StudentAssessment>;
  studentAssessments: Array<StudentAssessment>;
  studentAssessmentOutcome?: Maybe<StudentAssessmentOutcome>;
  studentAssessmentOutcomes: Array<StudentAssessmentOutcome>;
  studentChecklist?: Maybe<StudentChecklist>;
  studentChecklists: Array<StudentChecklist>;
  studentChecklistOutcome?: Maybe<StudentChecklistOutcome>;
  studentChecklistOutcomes: Array<StudentChecklistOutcome>;
  unit?: Maybe<Unit>;
  units: Array<Unit>;
  _dummyCore?: Maybe<Scalars['Boolean']>;
  apps: Array<Maybe<App>>;
  /**
   * - Required privileges:
   *   - academic-session.read
   */
  academicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.read
   */
  academicSessions: Array<Maybe<AcademicSession>>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  classroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  classrooms?: Maybe<Array<Classroom>>;
  classroomPrivilege?: Maybe<ClassroomPrivilege>;
  classroomPrivileges?: Maybe<Array<Maybe<ClassroomPrivilege>>>;
  classroomRole?: Maybe<ClassroomRole>;
  classroomRoles?: Maybe<Array<Maybe<ClassroomRole>>>;
  /**
   * - Required privileges:
   *   - classroom-setting.read
   */
  classroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.read
   */
  classroomSettings: Array<Maybe<ClassroomSetting>>;
  /**
   * - Required privileges:
   *   - contact.read
   */
  contact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.read
   */
  contacts: Array<Maybe<Contact>>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  enrollment?: Maybe<Enrollment>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  enrollments?: Maybe<Array<Maybe<Enrollment>>>;
  featureToggle?: Maybe<FeatureToggle>;
  featureToggles: Array<Maybe<FeatureToggle>>;
  group?: Maybe<Group>;
  groups: Array<Maybe<Group>>;
  defaultGroupSettings?: Maybe<Array<DefaultGroupSetting>>;
  groupCategory?: Maybe<GroupCategory>;
  groupCategories: Array<Maybe<GroupCategory>>;
  groupEnrollment?: Maybe<GroupEnrollment>;
  groupEnrollments: Array<Maybe<GroupEnrollment>>;
  /**
   * - Required privileges:
   *   - organization.read
   */
  organization?: Maybe<Organization>;
  /**
   * - Required privileges:
   *   - organization.read
   */
  organizations: Array<Maybe<Organization>>;
  organizationPrivilege?: Maybe<OrganizationPrivilege>;
  organizationPrivileges?: Maybe<Array<Maybe<OrganizationPrivilege>>>;
  organizationRole?: Maybe<OrganizationRole>;
  organizationRoles?: Maybe<Array<Maybe<OrganizationRole>>>;
  organizationSetting?: Maybe<OrganizationSetting>;
  organizationSettings: Array<Maybe<OrganizationSetting>>;
  product?: Maybe<Product>;
  products: Array<Maybe<Product>>;
  productBundle?: Maybe<ProductBundle>;
  productBundles: Array<Maybe<ProductBundle>>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculums: Array<ProductCurriculum>;
  productFamily?: Maybe<ProductFamily>;
  productFamilies: Array<Maybe<ProductFamily>>;
  /**
   * - Required privileges:
   *   - student.read
   */
  student?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student.read
   */
  students: Array<Maybe<Student>>;
  /**
   * - Required privileges:
   *   - student.read
   */
  studentSearch: Array<Student>;
  /**
   * - Required privileges:
   *   - student-setting.read
   */
  studentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.read
   */
  studentSettings: Array<Maybe<StudentSetting>>;
  tour?: Maybe<Tour>;
  tours: Array<Maybe<Tour>>;
  toursSettings: Array<Maybe<TourSettings>>;
  tourStep?: Maybe<TourStep>;
  tourSteps: Array<Maybe<TourStep>>;
  me?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.read
   */
  user?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.read
   */
  users: Array<User>;
  /**
   * - Required privileges:
   *   - user.read
   */
  userSearch: Array<User>;
  /**
   * - Required privileges:
   *   - user-setting.read
   */
  userSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.read
   */
  userSettings: Array<Maybe<UserSetting>>;
  _dummyFulfillment?: Maybe<Scalars['Boolean']>;
  mastercode?: Maybe<Mastercode>;
  mastercodes?: Maybe<Array<Mastercode>>;
  mastercodeTransferHistory?: Maybe<MastercodeTransferHistory>;
  mastercodeTransferHistories?: Maybe<Array<MastercodeTransferHistory>>;
  order?: Maybe<Order>;
  orders?: Maybe<Array<Order>>;
  _dummyLicenseManager?: Maybe<Scalars['Boolean']>;
  license?: Maybe<License>;
  licenses: Array<Maybe<License>>;
  availableLicenses: Array<Maybe<License>>;
  siteLicense?: Maybe<SiteLicense>;
  siteLicenses: Array<Maybe<SiteLicense>>;
};


export type QueryAssessmentArgs = {
  where: AssessmentWhereInput;
};


export type QueryAssessmentsArgs = {
  where?: Maybe<AssessmentsWhereInput>;
  orderBy?: Maybe<AssessmentsOrderInput>;
};


export type QueryChecklistArgs = {
  where: ChecklistWhereInput;
};


export type QueryChecklistsArgs = {
  where?: Maybe<ChecklistsWhereInput>;
  orderBy?: Maybe<ChecklistsOrderInput>;
};


export type QueryDomainArgs = {
  where: DomainWhereInput;
};


export type QueryDomainsArgs = {
  where?: Maybe<DomainsWhereInput>;
  orderBy?: Maybe<DomainsOrderInput>;
};


export type QueryEducatorPacketArgs = {
  where: EducatorPacketWhereInput;
};


export type QueryEducatorPacketsArgs = {
  where?: Maybe<EducatorPacketsWhereInput>;
  orderBy?: Maybe<EducatorPacketsOrderInput>;
};


export type QueryAssessmentReportArgs = {
  where: AssessmentReportWhereInput;
};


export type QueryAssessmentReportsArgs = {
  where: AssessmentReportsWhereInput;
};


export type QueryStudentAssessmentArgs = {
  where: StudentAssessmentWhereInput;
};


export type QueryStudentAssessmentsArgs = {
  where: StudentAssessmentsWhereInput;
  orderBy?: Maybe<StudentAssessmentsOrderInput>;
};


export type QueryStudentAssessmentOutcomeArgs = {
  where: StudentAssessmentOutcomeWhereInput;
};


export type QueryStudentAssessmentOutcomesArgs = {
  where?: Maybe<StudentAssessmentOutcomesWhereInput>;
  orderBy?: Maybe<StudentAssessmentOutcomesOrderInput>;
};


export type QueryStudentChecklistArgs = {
  where: StudentChecklistWhereInput;
};


export type QueryStudentChecklistsArgs = {
  where?: Maybe<StudentChecklistsWhereInput>;
  orderBy?: Maybe<StudentChecklistsOrderInput>;
};


export type QueryStudentChecklistOutcomeArgs = {
  where: StudentChecklistOutcomeWhereInput;
};


export type QueryStudentChecklistOutcomesArgs = {
  where?: Maybe<StudentChecklistOutcomesWhereInput>;
  orderBy?: Maybe<StudentChecklistOutcomesOrderInput>;
};


export type QueryUnitArgs = {
  where: UnitWhereInput;
};


export type QueryUnitsArgs = {
  where?: Maybe<UnitsWhereInput>;
  orderBy?: Maybe<UnitsOrderInput>;
};


export type QueryAcademicSessionArgs = {
  where: AcademicSessionWhereInput;
};


export type QueryAcademicSessionsArgs = {
  where?: Maybe<AcademicSessionsWhereInput>;
  orderBy?: Maybe<AcademicSessionsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryClassroomArgs = {
  where: ClassroomWhereInput;
};


export type QueryClassroomsArgs = {
  where?: Maybe<ClassroomsWhereInput>;
  whereUser?: Maybe<UsersWhereInput>;
  orderBy?: Maybe<ClassroomsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryClassroomPrivilegeArgs = {
  where: ClassroomPrivilegeWhereInput;
};


export type QueryClassroomPrivilegesArgs = {
  where?: Maybe<ClassroomPrivilegesWhereInput>;
  orderBy?: Maybe<ClassroomPrivilegesOrderInput>;
};


export type QueryClassroomRoleArgs = {
  where: ClassroomRoleWhereInput;
};


export type QueryClassroomRolesArgs = {
  where?: Maybe<ClassroomRolesWhereInput>;
  orderBy?: Maybe<ClassroomRolesOrderInput>;
};


export type QueryClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
};


export type QueryClassroomSettingsArgs = {
  where?: Maybe<ClassroomSettingsWhereInput>;
  orderBy?: Maybe<ClassroomSettingsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryContactArgs = {
  where: ContactWhereInput;
};


export type QueryContactsArgs = {
  where?: Maybe<ContactsWhereInput>;
  orderBy?: Maybe<ContactsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryEnrollmentArgs = {
  where: EnrollmentWhereInput;
};


export type QueryEnrollmentsArgs = {
  where?: Maybe<EnrollmentsWhereInput>;
  orderBy?: Maybe<EnrollmentsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryFeatureToggleArgs = {
  where: FeatureToggleWhereInput;
};


export type QueryFeatureTogglesArgs = {
  where?: Maybe<FeatureTogglesWhereInput>;
  orderBy?: Maybe<FeatureTogglesOrderInput>;
};


export type QueryGroupArgs = {
  where: GroupWhereInput;
};


export type QueryGroupsArgs = {
  where: GroupsWhereInput;
  orderBy?: Maybe<GroupsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryGroupCategoryArgs = {
  where: GroupCategoryWhereInput;
};


export type QueryGroupCategoriesArgs = {
  where: GroupCategoriesWhereInput;
  orderBy?: Maybe<GroupCategoriesOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryGroupEnrollmentArgs = {
  where: GroupEnrollmentWhereInput;
};


export type QueryGroupEnrollmentsArgs = {
  where: GroupEnrollmentsWhereInput;
  orderBy?: Maybe<GroupEnrollmentsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryOrganizationArgs = {
  where: OrganizationWhereInput;
};


export type QueryOrganizationsArgs = {
  where?: Maybe<OrganizationsWhereInput>;
  whereUserOrganization?: Maybe<UserOrganizationInput>;
  orderBy?: Maybe<OrganizationsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryOrganizationPrivilegeArgs = {
  where: OrganizationPrivilegeWhereInput;
};


export type QueryOrganizationPrivilegesArgs = {
  where?: Maybe<OrganizationPrivilegesWhereInput>;
  orderBy?: Maybe<OrganizationPrivilegesOrderInput>;
};


export type QueryOrganizationRoleArgs = {
  where: OrganizationRoleWhereInput;
};


export type QueryOrganizationRolesArgs = {
  where?: Maybe<OrganizationRolesWhereInput>;
  orderBy?: Maybe<OrganizationRolesOrderInput>;
};


export type QueryOrganizationSettingArgs = {
  where: OrganizationSettingWhereInput;
};


export type QueryOrganizationSettingsArgs = {
  where?: Maybe<OrganizationSettingsWhereInput>;
  orderBy?: Maybe<OrganizationSettingsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryProductArgs = {
  where: ProductWhereInput;
};


export type QueryProductsArgs = {
  where?: Maybe<ProductsWhereInput>;
  orderBy?: Maybe<ProductsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryProductBundleArgs = {
  where: ProductBundleWhereInput;
};


export type QueryProductBundlesArgs = {
  where?: Maybe<ProductBundlesWhereInput>;
  orderBy?: Maybe<ProductBundlesOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryProductCurriculumArgs = {
  where: ProductCurriculumWhereInput;
};


export type QueryProductCurriculumsArgs = {
  where?: Maybe<ProductCurriculumsWhereInput>;
  orderBy?: Maybe<ProductCurriculumsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryProductFamilyArgs = {
  where: ProductFamilyWhereInput;
};


export type QueryProductFamiliesArgs = {
  where?: Maybe<ProductFamiliesWhereInput>;
  orderBy?: Maybe<ProductFamiliesOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryStudentArgs = {
  where: StudentWhereInput;
};


export type QueryStudentsArgs = {
  where?: Maybe<StudentsWhereInput>;
  orderBy?: Maybe<StudentsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryStudentSearchArgs = {
  searchText: Scalars['String'];
  searchFields?: Maybe<Array<StudentSearchField>>;
  classroomId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  where?: Maybe<StudentsWhereInput>;
  orderBy?: Maybe<StudentsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryStudentSettingArgs = {
  where: StudentSettingWhereInput;
};


export type QueryStudentSettingsArgs = {
  where?: Maybe<StudentSettingsWhereInput>;
  orderBy?: Maybe<StudentSettingsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryTourArgs = {
  where: TourWhereInput;
};


export type QueryToursArgs = {
  where: ToursWhereInput;
  orderBy?: Maybe<ToursOrderInput>;
};


export type QueryToursSettingsArgs = {
  where: ToursSettingsWhereInput;
};


export type QueryTourStepArgs = {
  where: TourStepWhereInput;
};


export type QueryTourStepsArgs = {
  where: TourStepsWhereInput;
};


export type QueryUserArgs = {
  where: UserWhereInput;
};


export type QueryUsersArgs = {
  where?: Maybe<UsersWhereInput>;
  orderBy?: Maybe<UsersOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryUserSearchArgs = {
  searchText: Scalars['String'];
  searchFields?: Maybe<Array<UserSearchField>>;
  classroomId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  where?: Maybe<UsersWhereInput>;
  orderBy?: Maybe<UsersOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryUserSettingArgs = {
  where: UserSettingWhereInput;
};


export type QueryUserSettingsArgs = {
  where?: Maybe<UserSettingsWhereInput>;
  orderBy?: Maybe<UserSettingsOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryMastercodeArgs = {
  where: MastercodeWhereInput;
};


export type QueryMastercodesArgs = {
  where: MastercodesWhereInput;
  orderBy?: Maybe<MastercodesOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryMastercodeTransferHistoryArgs = {
  where: MastercodeTransferHistoryWhereInput;
};


export type QueryMastercodeTransferHistoriesArgs = {
  where: MastercodeTransferHistoriesWhereInput;
  orderBy?: Maybe<MastercodeTransferHistoryOrderInput>;
};


export type QueryOrderArgs = {
  where: OrderWhereInput;
};


export type QueryOrdersArgs = {
  where?: Maybe<OrdersWhereInput>;
  orderBy?: Maybe<OrdersOrderInput>;
  paging?: Maybe<PagingInput>;
  mastercodeWhere?: Maybe<MastercodesWhereInput>;
};


export type QueryLicenseArgs = {
  where: LicenseWhereInput;
};


export type QueryLicensesArgs = {
  where?: Maybe<LicensesWhereInput>;
  orderBy?: Maybe<LicensesOrderInput>;
  paging?: Maybe<PagingInput>;
};


export type QueryAvailableLicensesArgs = {
  where: FindAvailableLicenseWhereInput;
};


export type QuerySiteLicenseArgs = {
  where: SiteLicenseWhereInput;
};


export type QuerySiteLicensesArgs = {
  where?: Maybe<SiteLicensesWhereInput>;
  orderBy?: Maybe<SiteLicensesOrderInput>;
};

export type Remediation = {
  __typename?: 'Remediation';
  id: Scalars['Int'];
  text: Scalars['String'];
};

export type SaveTourSettingsInput = {
  tourId: Scalars['Int'];
  tourStepSettings: Array<SaveTourStepSettingInput>;
};

export type SaveTourStepSettingInput = {
  tourStepId: Scalars['Int'];
  viewed: Scalars['Boolean'];
};

export type SaveToursSettingsInput = {
  userId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  toursSettings: Array<SaveTourSettingsInput>;
};

export type SiteLicense = {
  __typename?: 'SiteLicense';
  id: Scalars['Int'];
  licenseRangeMin: Scalars['Int'];
  licenseRangeMax: Scalars['Int'];
  licenseType: LicenseType;
  orderItemId: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  ownerUser?: Maybe<User>;
  ownerUserId: Scalars['Int'];
  productFamily?: Maybe<ProductFamily>;
  productFamilyId: Scalars['Int'];
  dateExpiration: Scalars['DateTime'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export enum SiteLicenseOrderField {
  Id = 'ID',
  DateCreated = 'DATE_CREATED',
  DateExpiration = 'DATE_EXPIRATION',
  DateUpdatedAssignment = 'DATE_UPDATED_ASSIGNMENT',
  DateUpdated = 'DATE_UPDATED',
  ProductId = 'PRODUCT_ID'
}

export type SiteLicenseUpdateInput = {
  dateExpiration?: Maybe<Scalars['DateTime']>;
  orderItemId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
};

export type SiteLicenseWhereInput = {
  id: Scalars['Int'];
};

export type SiteLicensesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<SiteLicenseOrderField>;
};

export type SiteLicensesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  expired?: Maybe<Scalars['Boolean']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  productFamily?: Maybe<Array<ProductIdentifierInput>>;
  ownerUserId?: Maybe<Array<Scalars['Int']>>;
};

export enum SourceKind {
  OneRoster = 'ONE_ROSTER',
  Clever = 'CLEVER',
  ClassLink = 'CLASS_LINK',
  Google = 'GOOGLE',
  Firebase = 'FIREBASE'
}

export type Student = {
  __typename?: 'Student';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sisId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  loginType: StudentLoginType;
  password?: Maybe<Scalars['String']>;
  gradeLevel: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  classrooms?: Maybe<Array<Classroom>>;
  contacts?: Maybe<Array<Contact>>;
  status?: Maybe<StudentStatus>;
  settings?: Maybe<Array<StudentSetting>>;
  toursSettings?: Maybe<Array<TourSettings>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  groups?: Maybe<Array<Group>>;
  licenses?: Maybe<Array<License>>;
  licenseUsage?: Maybe<Array<StudentLicenseUsage>>;
};


export type StudentSettingsArgs = {
  where?: Maybe<StudentSettingsWhereInput>;
  orderBy?: Maybe<StudentSettingsOrderInput>;
};


export type StudentToursSettingsArgs = {
  where?: Maybe<ToursSettingsWhereInput>;
};


export type StudentGroupsArgs = {
  where?: Maybe<GroupsWhereInput>;
  orderBy?: Maybe<GroupsOrderInput>;
};


export type StudentLicensesArgs = {
  where?: Maybe<LicensesWhereInput>;
  orderBy?: Maybe<LicensesOrderInput>;
};


export type StudentLicenseUsageArgs = {
  where?: Maybe<LicenseUsageWhereInput>;
};

export type StudentAssessment = {
  __typename?: 'StudentAssessment';
  id: Scalars['Int'];
  assessmentId: Scalars['Int'];
  studentId: Scalars['Int'];
  dateAdministered: Scalars['Date'];
  dateCompleted?: Maybe<Scalars['Date']>;
  comments?: Maybe<Scalars['String']>;
  stats: StudentAssessmentStats;
  assessmentDomains: Array<StudentAssessmentDomain>;
  outcomes: Array<StudentAssessmentOutcome>;
  student?: Maybe<Student>;
  assessment: Assessment;
};

export type StudentAssessmentCreateInput = {
  assessmentId: Scalars['Int'];
  studentId: Scalars['Int'];
  dateAdministered: Scalars['Date'];
  dateCompleted?: Maybe<Scalars['Date']>;
  comments?: Maybe<Scalars['String']>;
};

export type StudentAssessmentDomain = {
  __typename?: 'StudentAssessmentDomain';
  assessmentId: Scalars['Int'];
  studentAssessmentId: Scalars['Int'];
  domainId: Scalars['Int'];
  domain: Domain;
  stats: StudentAssessmentDomainStats;
  assessmentSections: Array<StudentAssessmentSection>;
};

export type StudentAssessmentDomainStats = {
  __typename?: 'StudentAssessmentDomainStats';
  pointsScored?: Maybe<Scalars['Int']>;
  pointsPossible?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

export type StudentAssessmentId = {
  assessmentId: Scalars['Int'];
  studentId: Scalars['Int'];
};

export enum StudentAssessmentOrderField {
  Id = 'ID',
  AssessmentId = 'ASSESSMENT_ID',
  StudentId = 'STUDENT_ID'
}

export type StudentAssessmentOutcome = {
  __typename?: 'StudentAssessmentOutcome';
  id: Scalars['Int'];
  assessmentId: Scalars['Int'];
  studentId: Scalars['Int'];
  studentAssessmentId: Scalars['Int'];
  assessmentSectionId: Scalars['Int'];
  assessmentQuestionId: Scalars['Int'];
  answerTypeId: Scalars['Int'];
  answerTypeOptionId?: Maybe<Scalars['Int']>;
  answerType: AnswerType;
  answerTypeOption?: Maybe<AnswerTypeOption>;
  assessment: Assessment;
  assessmentSection: AssessmentSection;
  assessmentQuestion: AssessmentQuestion;
  student?: Maybe<Student>;
  studentAssessment: StudentAssessment;
};

export type StudentAssessmentOutcomeCreateInput = {
  studentId: Scalars['Int'];
  assessmentId: Scalars['Int'];
  assessmentSectionId: Scalars['Int'];
  assessmentQuestionId: Scalars['Int'];
  answerTypeOptionId: Scalars['Int'];
};

export type StudentAssessmentOutcomeId = {
  studentId: Scalars['Int'];
  assessmentId: Scalars['Int'];
  assessmentSectionId: Scalars['Int'];
  assessmentQuestionId: Scalars['Int'];
};

export enum StudentAssessmentOutcomeOrderField {
  Id = 'ID',
  AssessmentId = 'ASSESSMENT_ID',
  AssessmentQuestionId = 'ASSESSMENT_QUESTION_ID',
  StudentId = 'STUDENT_ID'
}

export type StudentAssessmentOutcomeUpdateInput = {
  answerTypeOptionId?: Maybe<Scalars['Int']>;
};

export type StudentAssessmentOutcomeWhereInput = {
  id?: Maybe<Scalars['Int']>;
  studentAssessmentOutcomeId?: Maybe<StudentAssessmentOutcomeId>;
};

export type StudentAssessmentOutcomesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<StudentAssessmentOutcomeOrderField>;
};

export type StudentAssessmentOutcomesWhereInput = {
  assessmentId?: Maybe<Array<Scalars['Int']>>;
  studentId?: Maybe<Array<Scalars['Int']>>;
  assessmentSectionId?: Maybe<Array<Scalars['Int']>>;
  assessmentQuestionId?: Maybe<Array<Scalars['Int']>>;
};

export type StudentAssessmentReportDomain = {
  __typename?: 'StudentAssessmentReportDomain';
  assessmentId: Scalars['Int'];
  domainId: Scalars['Int'];
  domain: Domain;
  remediations: Array<Remediation>;
  stats?: Maybe<Array<StudentAssessmentReportDomainStats>>;
};

export type StudentAssessmentReportDomainStats = StudentReportStats & {
  __typename?: 'StudentAssessmentReportDomainStats';
  assessmentId: Scalars['Int'];
  domainId: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  studentIds: Array<Scalars['Int']>;
  students: Array<Maybe<Student>>;
};

export type StudentAssessmentReportSection = {
  __typename?: 'StudentAssessmentReportSection';
  assessmentId: Scalars['Int'];
  assessmentSectionId: Scalars['Int'];
  assessmentSection: AssessmentSection;
  stats?: Maybe<Array<StudentAssessmentReportSectionStats>>;
};

export type StudentAssessmentReportSectionStats = StudentReportStats & {
  __typename?: 'StudentAssessmentReportSectionStats';
  assessmentSectionId: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  studentIds: Array<Scalars['Int']>;
  students: Array<Maybe<Student>>;
  assessmentSection: AssessmentSection;
};

export type StudentAssessmentReportTotalStats = StudentReportStats & {
  __typename?: 'StudentAssessmentReportTotalStats';
  score?: Maybe<Scalars['Int']>;
  studentIds: Array<Scalars['Int']>;
  students: Array<Maybe<Student>>;
};

export type StudentAssessmentSection = {
  __typename?: 'StudentAssessmentSection';
  assessmentId: Scalars['Int'];
  assessmentSectionId: Scalars['Int'];
  studentAssessmentId: Scalars['Int'];
  assessmentSection: AssessmentSection;
  stats: StudentAssessmentSectionStats;
  assessmentSectionQuestions: Array<StudentAssessmentSectionQuestion>;
};

export type StudentAssessmentSectionQuestion = {
  __typename?: 'StudentAssessmentSectionQuestion';
  assessmentQuestion: AssessmentQuestion;
  outcome?: Maybe<StudentAssessmentOutcome>;
};

export type StudentAssessmentSectionStats = {
  __typename?: 'StudentAssessmentSectionStats';
  pointsScored?: Maybe<Scalars['Int']>;
  pointsPossible?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

export type StudentAssessmentStats = {
  __typename?: 'StudentAssessmentStats';
  pointsScored?: Maybe<Scalars['Int']>;
  pointsPossible?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

export type StudentAssessmentUpdateInput = {
  dateAdministered?: Maybe<Scalars['Date']>;
  dateCompleted?: Maybe<Scalars['Date']>;
  comments?: Maybe<Scalars['String']>;
};

export type StudentAssessmentWhereInput = {
  id?: Maybe<Scalars['Int']>;
  studentAssessmentId?: Maybe<StudentAssessmentId>;
};

export type StudentAssessmentsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<StudentAssessmentOrderField>;
};

export type StudentAssessmentsWhereInput = {
  assessmentId?: Maybe<Array<Scalars['Int']>>;
  studentId?: Maybe<Array<Scalars['Int']>>;
};

export type StudentChecklist = {
  __typename?: 'StudentChecklist';
  id: Scalars['Int'];
  checklistId: Scalars['Int'];
  studentId: Scalars['Int'];
  dateAdministered: Scalars['Date'];
  dateCompleted?: Maybe<Scalars['Date']>;
  comments?: Maybe<Scalars['String']>;
  stats: StudentChecklistStats;
  checklistDomains: Array<StudentChecklistDomain>;
  outcomes: Array<StudentChecklistOutcome>;
  student?: Maybe<Student>;
  checklist: Checklist;
};

export type StudentChecklistCreateInput = {
  checklistId: Scalars['Int'];
  studentId: Scalars['Int'];
  dateAdministered: Scalars['Date'];
  dateCompleted?: Maybe<Scalars['Date']>;
  comments?: Maybe<Scalars['String']>;
};

export type StudentChecklistDomain = {
  __typename?: 'StudentChecklistDomain';
  checklistId: Scalars['Int'];
  studentChecklistId: Scalars['Int'];
  domainId: Scalars['Int'];
  domain: Domain;
  stats: StudentChecklistDomainStats;
  checklistObservations: Array<StudentChecklistObservation>;
};

export type StudentChecklistDomainStats = {
  __typename?: 'StudentChecklistDomainStats';
  studentChecklistId: Scalars['Int'];
  domainId: Scalars['Int'];
  pointsScored?: Maybe<Scalars['Int']>;
  pointsPossible?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

export type StudentChecklistId = {
  checklistId: Scalars['Int'];
  studentId: Scalars['Int'];
};

export type StudentChecklistObservation = {
  __typename?: 'StudentChecklistObservation';
  observation: Observation;
  outcome?: Maybe<StudentChecklistOutcome>;
};

export enum StudentChecklistOrderField {
  Id = 'ID',
  ChecklistId = 'CHECKLIST_ID',
  StudentId = 'STUDENT_ID'
}

export type StudentChecklistOutcome = {
  __typename?: 'StudentChecklistOutcome';
  id: Scalars['Int'];
  checklistId: Scalars['Int'];
  studentId: Scalars['Int'];
  studentChecklistId: Scalars['Int'];
  observationId: Scalars['Int'];
  /** @deprecated Use 'score' instead */
  value?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  checklist: Checklist;
  observation: Observation;
  student?: Maybe<Student>;
  studentChecklist: StudentChecklist;
};

export type StudentChecklistOutcomeCreateInput = {
  studentId: Scalars['Int'];
  checklistId: Scalars['Int'];
  observationId: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
};

export type StudentChecklistOutcomeId = {
  studentId: Scalars['Int'];
  checklistId: Scalars['Int'];
  observationId: Scalars['Int'];
};

export enum StudentChecklistOutcomeOrderField {
  Id = 'ID',
  ChecklistId = 'CHECKLIST_ID',
  ObservationId = 'OBSERVATION_ID',
  StudentId = 'STUDENT_ID'
}

export type StudentChecklistOutcomeUpdateInput = {
  score?: Maybe<Scalars['Int']>;
};

export type StudentChecklistOutcomeWhereInput = {
  id?: Maybe<Scalars['Int']>;
  studentChecklistOutcomeId?: Maybe<StudentChecklistOutcomeId>;
};

export type StudentChecklistOutcomesOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<StudentChecklistOutcomeOrderField>;
};

export type StudentChecklistOutcomesWhereInput = {
  checklistId?: Maybe<Array<Scalars['Int']>>;
  studentId?: Maybe<Array<Scalars['Int']>>;
  observationId?: Maybe<Array<Scalars['Int']>>;
};

export type StudentChecklistStats = {
  __typename?: 'StudentChecklistStats';
  studentChecklistId: Scalars['Int'];
  pointsScored?: Maybe<Scalars['Int']>;
  pointsPossible?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

export type StudentChecklistUpdateInput = {
  dateAdministered?: Maybe<Scalars['Date']>;
  dateCompleted?: Maybe<Scalars['Date']>;
  comments?: Maybe<Scalars['String']>;
};

export type StudentChecklistWhereInput = {
  id?: Maybe<Scalars['Int']>;
  studentChecklistId?: Maybe<StudentChecklistId>;
};

export type StudentChecklistsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<StudentChecklistOrderField>;
};

export type StudentChecklistsWhereInput = {
  checklistId?: Maybe<Array<Scalars['Int']>>;
  studentId?: Maybe<Array<Scalars['Int']>>;
};

export type StudentContact = {
  __typename?: 'StudentContact';
  studentId: Scalars['Int'];
  contactId: Scalars['Int'];
};

export type StudentCreateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  loginType?: Maybe<StudentLoginType>;
  password?: Maybe<Scalars['String']>;
  gradeLevel: Scalars['String'];
  organizationId: Scalars['Int'];
  classroomId?: Maybe<Array<Scalars['Int']>>;
  licenses?: Maybe<Array<CreateEntityLicenseAssignInput>>;
  settings?: Maybe<Array<BaseSettingCreateInput>>;
  group?: Maybe<Array<GroupUpsertInput>>;
};

export type StudentLicenseUsage = {
  __typename?: 'StudentLicenseUsage';
  product: Product;
  productId: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  assignedCount: Scalars['Int'];
  active: Scalars['Boolean'];
  manualAssignment: Scalars['Boolean'];
  trial: Scalars['Boolean'];
};

export enum StudentLoginType {
  LetterCards = 'LETTER_CARDS',
  Textbox = 'TEXTBOX'
}

export type StudentReportStats = {
  score?: Maybe<Scalars['Int']>;
  studentIds: Array<Scalars['Int']>;
  students: Array<Maybe<Student>>;
};

export enum StudentSearchField {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type StudentSetting = {
  __typename?: 'StudentSetting';
  /** @deprecated Field no longer supported */
  id: Scalars['Int'];
  app?: Maybe<App>;
  appId?: Maybe<Scalars['Int']>;
  student: Student;
  studentId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type StudentSettingCreateInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  studentId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export enum StudentSettingOrderField {
  AppId = 'APP_ID',
  Setting = 'SETTING',
  StudentId = 'STUDENT_ID'
}

export type StudentSettingUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type StudentSettingWhereInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  studentId: Scalars['Int'];
  setting: Scalars['String'];
};

export type StudentSettingsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<StudentSettingOrderField>;
};

export type StudentSettingsUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type StudentSettingsWhereInput = {
  appId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  appName?: Maybe<Array<Maybe<Scalars['String']>>>;
  studentId?: Maybe<Array<Scalars['Int']>>;
  setting?: Maybe<Array<Scalars['String']>>;
};

export enum StudentStatus {
  Active = 'ACTIVE',
  Removed = 'REMOVED'
}

export type StudentUpdateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  loginType?: Maybe<StudentLoginType>;
  password?: Maybe<Scalars['String']>;
  gradeLevel?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  groups?: Maybe<Array<GroupUpsertInput>>;
};

export type StudentWhereInput = {
  externalId?: Maybe<ExternalIdInput>;
  id?: Maybe<Scalars['Int']>;
  authToken?: Maybe<Scalars['String']>;
};

export enum StudentsOrderField {
  Id = 'ID',
  SourceId = 'SOURCE_ID',
  SourceKindId = 'SOURCE_KIND_ID',
  Username = 'USERNAME',
  Password = 'PASSWORD',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  GradeLevel = 'GRADE_LEVEL'
}

export type StudentsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<StudentsOrderField>;
};

export type StudentsUpdateInput = {
  loginType?: Maybe<StudentLoginType>;
  gradeLevel?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type StudentsWhereInput = {
  id?: Maybe<Array<Maybe<Scalars['Int']>>>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  authToken?: Maybe<Array<Scalars['String']>>;
  firstName?: Maybe<Array<Scalars['String']>>;
  firstName_contains?: Maybe<Scalars['String']>;
  lastName?: Maybe<Array<Scalars['String']>>;
  lastName_contains?: Maybe<Scalars['String']>;
  email?: Maybe<Array<Scalars['String']>>;
  email_contains?: Maybe<Scalars['String']>;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  username?: Maybe<Array<Scalars['String']>>;
  username_contains?: Maybe<Scalars['String']>;
  organizations?: Maybe<OrganizationsWhereInput>;
  classrooms?: Maybe<ClassroomsWhereInput>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Array<StudentStatus>>;
  AND?: Maybe<Array<StudentsWhereInput>>;
  OR?: Maybe<Array<StudentsWhereInput>>;
};

export type SwapLicensesInput = {
  toProductId: Scalars['Int'];
};

export type SwapLicensesWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  organizationId?: Maybe<Scalars['Int']>;
  fromProductId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  expiresAfter?: Maybe<Scalars['DateTime']>;
};

export type Tour = {
  __typename?: 'Tour';
  id: Scalars['Int'];
  appId: Scalars['Int'];
  app: App;
  name: Scalars['String'];
  tourSteps: Array<TourStep>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export enum TourOrderField {
  Id = 'ID',
  AppId = 'APP_ID',
  Name = 'NAME'
}

export type TourSettings = {
  __typename?: 'TourSettings';
  tourId: Scalars['Int'];
  tour?: Maybe<Tour>;
  tourStepSettings: Array<TourStepSetting>;
};

export type TourStep = {
  __typename?: 'TourStep';
  id: Scalars['Int'];
  tourId: Scalars['Int'];
  name: Scalars['String'];
  groupName?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  media?: Maybe<Media>;
  position?: Maybe<Position>;
  data?: Maybe<Scalars['JSON']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  tour: Tour;
};

export type TourStepSetting = {
  __typename?: 'TourStepSetting';
  tourStepId: Scalars['Int'];
  tourStep?: Maybe<TourStep>;
  viewed: Scalars['Boolean'];
};

export type TourStepWhereInput = {
  id?: Maybe<Scalars['Int']>;
  tourId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TourStepsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  tourId?: Maybe<Array<Scalars['Int']>>;
};

export type TourWhereInput = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
};

export type ToursOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<TourOrderField>;
};

export type ToursSettingsWhereInput = {
  userId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  tours?: Maybe<Array<Scalars['String']>>;
  toursSteps?: Maybe<Array<Scalars['String']>>;
  viewed?: Maybe<Scalars['Boolean']>;
};

export type ToursWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Array<Scalars['String']>>;
  appId?: Maybe<Array<Scalars['Int']>>;
  appName?: Maybe<Array<Scalars['String']>>;
};

export type TransferStudentInput = {
  fromClassroomId: Scalars['Int'];
  toClassroomId: Scalars['Int'];
};

export type TransferStudentWhereInput = {
  studentId: Scalars['Int'];
};

export type Unit = {
  __typename?: 'Unit';
  id: Scalars['Int'];
  productCurriculumId: Scalars['Int'];
  unitNumber: Scalars['Int'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  productCurriculum: ProductCurriculum;
};

export type UnitAssessment = Assessment & {
  __typename?: 'UnitAssessment';
  id: Scalars['Int'];
  type: AssessmentType;
  educatorPacketId?: Maybe<Scalars['Int']>;
  educatorPacket?: Maybe<EducatorPacket>;
  totalPointsPossible: Scalars['Int'];
  assessmentDomains: Array<AssessmentDomain>;
  assessmentSectionQuestions: Array<AssessmentSectionQuestion>;
  unitId: Scalars['Int'];
  unit: Unit;
};

export type UnitChecklist = Checklist & {
  __typename?: 'UnitChecklist';
  id: Scalars['Int'];
  type: AssessmentType;
  totalPointsPossible: Scalars['Int'];
  checklistDomains: Array<ChecklistDomain>;
  checklistObservations: Array<ChecklistObservation>;
  unitId: Scalars['Int'];
  unit: Unit;
};

export enum UnitOrderField {
  Id = 'ID',
  Title = 'TITLE',
  UnitNumber = 'UNIT_NUMBER'
}

export type UnitWhereInput = {
  id: Scalars['Int'];
};

export type UnitsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<UnitOrderField>;
};

export type UnitsWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  productCurriculumId?: Maybe<Array<Scalars['Int']>>;
};

export type User = {
  __typename?: 'User';
  id: Scalars['Int'];
  externalId?: Maybe<ExternalId>;
  sisId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  type: UserType;
  userTypeId: Scalars['Int'];
  pin: Scalars['String'];
  avatarUrl?: Maybe<Scalars['String']>;
  azureId?: Maybe<Scalars['String']>;
  status: UserStatus;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  classroomPrivileges?: Maybe<Array<UserClassroomPrivileges>>;
  classroomEnrollments?: Maybe<Array<UserClassroomEnrollment>>;
  organizationPrivileges?: Maybe<Array<UserOrganizationPrivileges>>;
  organizationAssociations?: Maybe<Array<UserOrganization>>;
  settings?: Maybe<Array<UserSetting>>;
  toursSettings?: Maybe<Array<TourSettings>>;
  mastercodes?: Maybe<Array<Mastercode>>;
  orders?: Maybe<Array<Order>>;
  licenses?: Maybe<Array<License>>;
  licenseUsage?: Maybe<Array<UserLicenseUsage>>;
};


export type UserSettingsArgs = {
  where?: Maybe<UserSettingsWhereInput>;
  orderBy?: Maybe<UserSettingsOrderInput>;
};


export type UserToursSettingsArgs = {
  where?: Maybe<ToursSettingsWhereInput>;
};


export type UserMastercodesArgs = {
  where?: Maybe<MastercodesWhereInput>;
  orderBy?: Maybe<MastercodesOrderInput>;
};


export type UserOrdersArgs = {
  where?: Maybe<OrdersWhereInput>;
  orderBy?: Maybe<OrdersOrderInput>;
};


export type UserLicensesArgs = {
  where?: Maybe<LicensesWhereInput>;
  orderBy?: Maybe<LicensesOrderInput>;
};


export type UserLicenseUsageArgs = {
  where?: Maybe<LicenseUsageWhereInput>;
};

export type UserClassroomEnrollment = {
  __typename?: 'UserClassroomEnrollment';
  classroom: Classroom;
  classroomId: Scalars['Int'];
  classroomRoles: Array<ClassroomRole>;
  classroomRoleIds: Array<Scalars['Int']>;
  user: User;
  userId: Scalars['Int'];
};

export type UserClassroomPrivileges = {
  __typename?: 'UserClassroomPrivileges';
  classroomId: Scalars['Int'];
  privileges?: Maybe<Array<Scalars['String']>>;
};

export type UserCreateInput = {
  externalId?: Maybe<ExternalIdInput>;
  sisId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  type?: Maybe<UserType>;
  pin?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  status?: Maybe<UserStatus>;
  organizationAssociations?: Maybe<Array<UserOrganizationInput>>;
  licenses?: Maybe<Array<CreateEntityLicenseAssignInput>>;
  settings?: Maybe<Array<BaseSettingCreateInput>>;
};

export type UserEnrollmentInput = {
  userId: Scalars['Int'];
  classroomRole?: Maybe<Array<UserRole>>;
};

export type UserLicenseUsage = {
  __typename?: 'UserLicenseUsage';
  product: Product;
  productId: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  assignedCount: Scalars['Int'];
  manualAssignment: Scalars['Boolean'];
  trial: Scalars['Boolean'];
};

export enum UserOrderField {
  Id = 'ID',
  SourceId = 'SOURCE_ID',
  SourceKindId = 'SOURCE_KIND_ID',
  Username = 'USERNAME',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type UserOrganization = {
  __typename?: 'UserOrganization';
  organization: Organization;
  organizationId: Scalars['Int'];
  organizationRoles: Array<OrganizationRole>;
  organizationRoleIds: Array<Scalars['Int']>;
  user: User;
  userId: Scalars['Int'];
};

export type UserOrganizationInput = {
  organizationId: Scalars['Int'];
  organizationRoleId: Array<Scalars['Int']>;
};

export type UserOrganizationPrivileges = {
  __typename?: 'UserOrganizationPrivileges';
  organizationId: Scalars['Int'];
  privileges?: Maybe<Array<Scalars['String']>>;
};

export type UserOrganizationWhereInput = {
  excludeAncestors?: Maybe<Scalars['Boolean']>;
};

export enum UserRole {
  Educator = 'EDUCATOR',
  EducatorGss = 'EDUCATOR_GSS',
  EducatorKey = 'EDUCATOR_KEY',
  Coeducator = 'COEDUCATOR',
  CoeducatorGss = 'COEDUCATOR_GSS',
  CoeducatorKey = 'COEDUCATOR_KEY'
}

export enum UserSearchField {
  Username = 'USERNAME',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type UserSetting = {
  __typename?: 'UserSetting';
  /** @deprecated Field no longer supported */
  id: Scalars['Int'];
  app?: Maybe<App>;
  appId?: Maybe<Scalars['Int']>;
  user: User;
  userId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
};

export type UserSettingCreateInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export enum UserSettingOrderField {
  AppId = 'APP_ID',
  Setting = 'SETTING',
  UserId = 'USER_ID'
}

export type UserSettingUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type UserSettingWhereInput = {
  appId?: Maybe<Scalars['Int']>;
  appName?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
  setting: Scalars['String'];
};

export type UserSettingsOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<UserSettingOrderField>;
};

export type UserSettingsUpdateInput = {
  setting?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['JSON']>;
};

export type UserSettingsWhereInput = {
  appId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  appName?: Maybe<Array<Maybe<Scalars['String']>>>;
  userId?: Maybe<Array<Scalars['Int']>>;
  setting?: Maybe<Array<Scalars['String']>>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export enum UserType {
  Administrator = 'ADMINISTRATOR',
  PrincipalVicePrincipal = 'PRINCIPAL_VICE_PRINCIPAL',
  Curriculum = 'CURRICULUM',
  K5Teacher = 'K5_TEACHER',
  PrekTeacher = 'PREK_TEACHER',
  TechnologyMedia = 'TECHNOLOGY_MEDIA',
  OccupationalTherapist = 'OCCUPATIONAL_THERAPIST',
  SpecialEducation = 'SPECIAL_EDUCATION',
  ParentFamily = 'PARENT_FAMILY',
  HomeschoolEducator = 'HOMESCHOOL_EDUCATOR',
  EslEsol = 'ESL_ESOL',
  Other = 'OTHER',
  ReadingSpecialist = 'READING_SPECIALIST'
}

export type UserUpdateInput = {
  externalId?: Maybe<ExternalIdUpdateInput>;
  sisId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  type?: Maybe<UserType>;
  pin?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  status?: Maybe<UserStatus>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  organizationAssociations?: Maybe<Array<UserOrganizationInput>>;
};

export type UserWhereInput = {
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<ExternalIdInput>;
  username?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
};

export type UsersOrderInput = {
  direction?: Maybe<Array<OrderDirection>>;
  field: Array<UserOrderField>;
};

export type UsersUpdateInput = {
  status?: Maybe<UserStatus>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
};

export type UsersWhereInput = {
  id?: Maybe<Array<Scalars['Int']>>;
  firstName?: Maybe<Array<Scalars['String']>>;
  firstName_contains?: Maybe<Scalars['String']>;
  lastName?: Maybe<Array<Scalars['String']>>;
  lastName_contains?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Array<Scalars['Int']>>;
  organizations?: Maybe<OrganizationsWhereInput>;
  organizationRoles?: Maybe<OrganizationRolesWhereInput>;
  pin?: Maybe<Array<Scalars['String']>>;
  username?: Maybe<Array<Scalars['String']>>;
  username_contains?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Array<Scalars['String']>>;
  sourceKind?: Maybe<Array<SourceKind>>;
  sisId?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Array<UserStatus>>;
  type?: Maybe<Array<UserType>>;
  includeRemoved?: Maybe<Scalars['Boolean']>;
  removed?: Maybe<Scalars['Boolean']>;
  AND?: Maybe<Array<UsersWhereInput>>;
  OR?: Maybe<Array<UsersWhereInput>>;
};

export type WeeklyChecklist = Checklist & {
  __typename?: 'WeeklyChecklist';
  id: Scalars['Int'];
  type: AssessmentType;
  totalPointsPossible: Scalars['Int'];
  checklistDomains: Array<ChecklistDomain>;
  checklistObservations: Array<ChecklistObservation>;
  weekNumber: Scalars['Int'];
  unitId: Scalars['Int'];
  unit: Unit;
};
